import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/sans-serif-ex.js
t.dynamicSetup("", "sans-serif-ex", e({
	SSX: { "sans-serif": {
		161: [
			.5,
			.194,
			.319
		],
		162: [
			.508,
			.064,
			.444
		],
		164: [
			.491,
			-.01,
			.778
		],
		166: [
			.75,
			.25,
			.278
		],
		169: [
			.694,
			0,
			.694
		],
		170: [
			.716,
			-.311,
			.372
		],
		171: [
			.439,
			0,
			.5
		],
		173: [
			.251,
			-.193,
			.333
		],
		174: [
			.694,
			0,
			.694
		],
		186: [
			.716,
			-.311,
			.419
		],
		187: [
			.439,
			0,
			.5
		],
		188: [
			.716,
			0,
			.788
		],
		189: [
			.716,
			0,
			.788
		],
		190: [
			.716,
			0,
			.788
		],
		191: [
			.5,
			.205,
			.472
		],
		3647: [
			.758,
			.064,
			.667
		],
		8218: [
			.084,
			.124,
			.278
		],
		8219: [
			.722,
			-.513,
			.278
		],
		8222: [
			.084,
			.124,
			.472
		],
		8223: [
			.722,
			-.513,
			.333
		],
		8226: [
			.407,
			-.121,
			.778
		],
		8233: [
			.722,
			.194,
			.472
		],
		8240: [
			.75,
			.056,
			1.154
		],
		8241: [
			.75,
			.056,
			1.471
		],
		8249: [
			.439,
			0,
			.333
		],
		8250: [
			.439,
			0,
			.333
		],
		8251: [
			.492,
			-.009,
			.778
		],
		8253: [
			.726,
			0,
			.472
		],
		8255: [
			.345,
			-.086,
			.333
		],
		8256: [
			.692,
			-.568,
			.597
		],
		8261: [
			.751,
			.309,
			.361
		],
		8262: [
			.751,
			.249,
			.361
		],
		8274: [
			.751,
			-.001,
			.5
		],
		8276: [
			-.07,
			.194,
			.597
		],
		8319: [
			.571,
			-.297,
			.31
		],
		8320: [
			.361,
			.028,
			.444
		],
		8353: [
			.79,
			.096,
			.639
		],
		8358: [
			.694,
			0,
			.708
		],
		8361: [
			.694,
			0,
			.944
		],
		8363: [
			.694,
			.064,
			.517
		],
		8369: [
			.694,
			0,
			.639
		],
		8370: [
			.75,
			.028,
			.778
		],
		8451: [
			.717,
			.021,
			.861
		],
		8470: [
			.695,
			0,
			.819
		],
		8471: [
			.694,
			0,
			.694
		],
		8478: [
			.694,
			0,
			.646
		],
		8480: [
			.694,
			-.252,
			.858
		],
		8482: [
			.698,
			-.282,
			.933
		],
		8494: [
			.712,
			.01,
			.669
		],
		8960: [
			.583,
			.083,
			.778
		],
		9250: [
			.694,
			.011,
			.517
		],
		9251: [
			.24,
			.118,
			.5
		],
		11800: [
			.528,
			.195,
			.472
		],
		64256: [
			.705,
			0,
			.583,
			{ ic: .041 }
		],
		64257: [
			.705,
			0,
			.536
		],
		64258: [
			.705,
			0,
			.536
		],
		64259: [
			.705,
			0,
			.814
		],
		64260: [
			.705,
			0,
			.814
		],
		65126: [
			.344,
			-.085,
			.333
		],
		184: [
			-.024,
			.192,
			.444
		],
		688: [
			.73,
			-.297,
			.31
		],
		689: [
			.727,
			-.297,
			.31
		],
		690: [
			.705,
			-.173,
			.16
		],
		691: [
			.57,
			-.297,
			.205
		],
		692: [
			.564,
			-.29,
			.205
		],
		693: [
			.564,
			-.167,
			.205,
			{ ic: .045 }
		],
		694: [
			.564,
			-.297,
			.27
		],
		695: [
			.564,
			-.297,
			.409
		],
		696: [
			.564,
			-.174,
			.276
		],
		697: [
			.694,
			-.495,
			.167
		],
		698: [
			.695,
			-.528,
			.5
		],
		699: [
			.695,
			-.486,
			.278
		],
		700: [
			.723,
			-.514,
			.278
		],
		701: [
			.695,
			-.486,
			.278
		],
		702: [
			.638,
			-.287,
			.396
		],
		703: [
			.638,
			-.287,
			.396
		],
		704: [
			.761,
			-.355,
			.444
		],
		705: [
			.761,
			-.355,
			.444
		],
		706: [
			.727,
			-.488,
			.333
		],
		707: [
			.727,
			-.488,
			.333
		],
		708: [
			.697,
			-.525,
			.5
		],
		709: [
			.697,
			-.525,
			.5
		],
		712: [
			.695,
			-.473,
			.222
		],
		716: [
			.027,
			.195,
			.222
		],
		718: [
			-.128,
			.258,
			.5
		],
		719: [
			-.128,
			.258,
			.5
		],
		720: [
			.445,
			0,
			.278
		],
		721: [
			.445,
			-.273,
			.278
		],
		722: [
			.425,
			-.142,
			.333
		],
		723: [
			.425,
			-.142,
			.333
		],
		724: [
			.283,
			-.086,
			.444
		],
		725: [
			.283,
			-.086,
			.444
		],
		726: [
			.283,
			0,
			.444
		],
		727: [
			.255,
			-.189,
			.444
		],
		731: [
			0,
			.212,
			.5
		],
		733: [
			.694,
			-.527,
			.5
		],
		734: [
			.483,
			-.22,
			.333
		],
		735: [
			.674,
			-.456,
			.5
		],
		736: [
			.564,
			-.167,
			.276
		],
		737: [
			.73,
			-.297,
			.143
		],
		738: [
			.575,
			-.29,
			.229
		],
		739: [
			.564,
			-.297,
			.276,
			{ ic: .005 }
		],
		740: [
			.72,
			-.297,
			.3
		],
		741: [
			.717,
			.022,
			.333,
			{ ic: .038 }
		],
		742: [
			.717,
			.022,
			.333,
			{ ic: .038 }
		],
		743: [
			.717,
			.022,
			.333,
			{ ic: .038 }
		],
		744: [
			.717,
			.022,
			.333,
			{ ic: .038 }
		],
		745: [
			.717,
			.023,
			.333,
			{ ic: .038 }
		],
		746: [
			.717,
			-.253,
			.333,
			{ ic: .034 }
		],
		747: [
			.717,
			.022,
			.343,
			{ ic: .061 }
		],
		748: [
			-.043,
			.215,
			.5
		],
		749: [
			.659,
			-.485,
			.5
		],
		750: [
			.723,
			-.514,
			.428
		],
		751: [
			.006,
			.212,
			.556,
			{ ic: .015 }
		],
		752: [
			.006,
			.212,
			.556,
			{ ic: .015 }
		],
		753: [
			-.043,
			.282,
			.333
		],
		754: [
			-.043,
			.282,
			.333
		],
		755: [
			-.04,
			.236,
			.296
		],
		756: [
			.325,
			-.158,
			.376
		],
		757: [
			.325,
			-.158,
			.546
		],
		758: [
			.325,
			-.158,
			.546
		],
		759: [
			-.041,
			.16,
			.433
		],
		760: [
			.544,
			-.292,
			.278
		],
		761: [
			.672,
			-.45,
			.289
		],
		762: [
			.672,
			-.45,
			.289
		],
		763: [
			.127,
			.095,
			.289
		],
		764: [
			.127,
			.095,
			.289
		],
		765: [
			.132,
			.096,
			.55
		],
		766: [
			.132,
			.096,
			.55
		],
		777: [
			.718,
			-.503,
			0,
			{ dx: .24 }
		],
		779: [
			.694,
			-.527,
			0,
			{ dx: .228 }
		],
		781: [
			.717,
			-.528,
			0,
			{ dx: .251 }
		],
		782: [
			.717,
			-.528,
			0,
			{ dx: .252 }
		],
		783: [
			.694,
			-.527,
			0,
			{ dx: .252 }
		],
		784: [
			.751,
			-.522,
			0,
			{ dx: .239 }
		],
		785: [
			.7,
			-.522,
			0,
			{ dx: .239 }
		],
		786: [
			.695,
			-.486,
			.278
		],
		787: [
			.694,
			-.511,
			0,
			{ dx: .086 }
		],
		788: [
			.694,
			-.511,
			0,
			{ dx: .137 }
		],
		789: [
			.868,
			-.659,
			0,
			{ dx: .002 }
		],
		790: [
			-.128,
			.258,
			0,
			{ dx: .297 }
		],
		791: [
			-.128,
			.258,
			0,
			{ dx: .204 }
		],
		792: [
			-.057,
			.309,
			.444
		],
		793: [
			-.057,
			.309,
			.444
		],
		794: [
			.806,
			-.584,
			.158,
			{ ic: .034 }
		],
		795: [
			.694,
			-.511,
			0,
			{ dx: .086 }
		],
		796: [
			-.041,
			.324,
			0,
			{ dx: .176 }
		],
		797: [
			-.057,
			.254,
			0,
			{ dx: .223 }
		],
		798: [
			-.057,
			.254,
			0,
			{ dx: .223 }
		],
		799: [
			-.057,
			.34,
			0,
			{ dx: .223 }
		],
		800: [
			-.051,
			.117,
			0,
			{ dx: .223 }
		],
		801: [
			.011,
			.217,
			0,
			{ dx: .185 }
		],
		802: [
			.011,
			.217,
			0,
			{ dx: .036 }
		],
		803: [
			-.111,
			.2,
			0,
			{ dx: .24 }
		],
		804: [
			-.066,
			.155,
			0,
			{ dx: .251 }
		],
		805: [
			-.052,
			.24,
			0,
			{ dx: .335 }
		],
		806: [
			-.079,
			.266,
			0,
			{ dx: .24 }
		],
		807: [
			-.023,
			.192,
			0,
			{ dx: .26 }
		],
		808: [
			.05,
			.214,
			0,
			{ dx: .189 }
		],
		809: [
			-.057,
			.279,
			0,
			{ dx: .112 }
		],
		810: [
			-.111,
			.295,
			0,
			{ dx: .251 }
		],
		811: [
			-.094,
			.303,
			0,
			{ dx: .251 }
		],
		812: [
			-.065,
			.206,
			0,
			{ dx: .251 }
		],
		813: [
			-.065,
			.206,
			0,
			{ dx: .251 }
		],
		814: [
			-.066,
			.244,
			0,
			{ dx: .239 }
		],
		815: [
			-.066,
			.244,
			0,
			{ dx: .239 }
		],
		816: [
			-.095,
			.214,
			0,
			{ dx: .239 }
		],
		817: [
			-.123,
			.187,
			0,
			{ dx: .239 }
		],
		818: [
			-.123,
			.187,
			0,
			{ dx: .239 }
		],
		819: [
			-.043,
			.227,
			0,
			{ dx: .239 }
		],
		820: [
			.319,
			-.209,
			0
		],
		821: [
			.272,
			-.216,
			0
		],
		822: [
			.272,
			-.216,
			0
		],
		823: [
			.353,
			-.098,
			0
		],
		825: [
			-.041,
			.324,
			0,
			{ dx: .159 }
		],
		826: [
			-.111,
			.295,
			0,
			{ dx: .251 }
		],
		827: [
			-.111,
			.325,
			0,
			{ dx: .251 }
		],
		828: [
			-.101,
			.266,
			0,
			{ dx: .25 }
		],
		829: [
			.674,
			-.456,
			0,
			{ dx: .251 }
		],
		830: [
			.827,
			-.494,
			0,
			{ dx: .239 }
		],
		831: [
			.682,
			-.542,
			.778
		],
		832: [
			.694,
			-.527,
			0,
			{ dx: .276 }
		],
		833: [
			.694,
			-.527,
			0,
			{ dx: .204 }
		],
		834: [
			.66,
			-.563,
			0,
			{ dx: .236 }
		],
		835: [
			.694,
			-.511,
			.222
		],
		836: [
			.694,
			-.489,
			.264
		],
		837: [
			-.067,
			.238,
			.111
		],
		838: [
			.676,
			-.492,
			0,
			{ dx: .251 }
		],
		839: [
			-.069,
			.328,
			0,
			{ dx: .19 }
		],
		840: [
			-.143,
			.332,
			0,
			{ dx: .252 }
		],
		841: [
			-.067,
			.289,
			0,
			{ dx: .168 }
		],
		842: [
			.74,
			-.466,
			0,
			{ dx: .239 }
		],
		843: [
			.741,
			-.489,
			0,
			{ dx: .239 }
		],
		844: [
			.685,
			-.485,
			.449
		],
		845: [
			-.025,
			.275,
			0,
			{ dx: .279 }
		],
		846: [
			-.041,
			.34,
			0,
			{ dx: .279 }
		],
		848: [
			.733,
			-.483,
			.273
		],
		849: [
			.7,
			-.504,
			.296
		],
		850: [
			.751,
			-.522,
			0,
			{ dx: .239 }
		],
		851: [
			-.042,
			.289,
			0,
			{ dx: .223 }
		],
		852: [
			-.025,
			.275,
			0,
			{ dx: .211 }
		],
		853: [
			-.025,
			.275,
			0,
			{ dx: .211 }
		],
		854: [
			-.025,
			.275,
			0,
			{ dx: .092 }
		],
		855: [
			.7,
			-.504,
			.296
		],
		856: [
			.655,
			-.566,
			0,
			{ dx: .051 }
		],
		857: [
			-.043,
			.269,
			.25
		],
		858: [
			-.052,
			.24,
			0,
			{ dx: .265 }
		],
		859: [
			.757,
			-.451,
			.5
		],
		860: [
			-.173,
			.354,
			0,
			{ dx: .29 }
		],
		861: [
			.668,
			-.488,
			0,
			{ dx: 0 }
		],
		862: [
			.587,
			-.518,
			0,
			{ dx: -.001 }
		],
		863: [
			-.118,
			.187,
			0,
			{ dx: -.001 }
		],
		864: [
			.723,
			-.568,
			0,
			{ dx: 0 }
		],
		865: [
			.668,
			-.488,
			0,
			{ dx: 0 }
		],
		866: [
			-.025,
			.275,
			0,
			{ dx: -.004 }
		],
		867: [
			.711,
			-.46,
			.25
		],
		868: [
			.71,
			-.459,
			.252
		],
		869: [
			.802,
			-.46,
			.135
		],
		870: [
			.71,
			-.459,
			.275
		],
		871: [
			.701,
			-.46,
			.275
		],
		872: [
			.711,
			-.459,
			.27
		],
		873: [
			.827,
			-.459,
			.267
		],
		874: [
			.822,
			-.462,
			.253
		],
		875: [
			.701,
			-.459,
			.411
		],
		876: [
			.702,
			-.46,
			.203
		],
		877: [
			.766,
			-.46,
			.214
		],
		878: [
			.694,
			-.457,
			.289
		],
		879: [
			.698,
			-.46,
			.307
		],
		7620: [
			.695,
			-.488,
			0,
			{ dx: .23 }
		],
		7621: [
			.695,
			-.488,
			0,
			{ dx: .271 }
		],
		7624: [
			.695,
			-.528,
			0,
			{ dx: .251 }
		],
		7625: [
			.695,
			-.528,
			0,
			{ dx: .251 }
		],
		9474: [
			.75,
			.25,
			.278
		],
		9553: [
			.75,
			.25,
			.5
		],
		9773: [
			.593,
			.001,
			.7
		],
		9792: [
			.467,
			.217,
			.5
		],
		9834: [
			.723,
			.03,
			.611
		],
		9901: [
			.473,
			-.029,
			.5,
			{ ic: .089 }
		],
		9902: [
			.615,
			.113,
			.5,
			{ ic: .2 }
		],
		9906: [
			.467,
			.217,
			.5
		],
		10013: [
			.625,
			.028,
			.5
		],
		59395: [
			.705,
			0,
			.792
		],
		59908: [
			.857,
			-.522,
			.5
		],
		59909: [
			-.066,
			.244,
			.5
		],
		59910: [
			-.066,
			.244,
			.5
		],
		59913: [
			.857,
			-.522,
			.5
		],
		59915: [
			.93,
			-.522,
			.5
		],
		59917: [
			.7,
			-.522,
			.5
		],
		59920: [
			.874,
			-.522,
			.5
		],
		59927: [
			.816,
			-.525,
			.5
		],
		59930: [
			.816,
			-.525,
			.5
		],
		59932: [
			.889,
			-.525,
			.5
		],
		59934: [
			.833,
			-.525,
			.5
		],
		59935: [
			-.079,
			.266,
			.5
		],
		59942: [
			.694,
			-.527,
			.5
		],
		59946: [
			.829,
			-.571,
			.5
		],
		59948: [
			.831,
			-.571,
			.5
		],
		59951: [
			.829,
			-.571,
			.5
		],
		59957: [
			.718,
			-.503,
			.5
		],
		59959: [
			.968,
			-.753,
			0,
			{ dx: .24 }
		],
		59962: [
			-.123,
			.187,
			.5
		],
		59966: [
			-.123,
			.187,
			.5
		],
		59970: [
			.842,
			-.517,
			.667
		],
		59973: [
			-.095,
			.214,
			.5
		],
		60163: [
			.868,
			.212,
			.667
		],
		60164: [
			.694,
			.212,
			.481
		],
		60168: [
			.694,
			0,
			.694
		],
		60175: [
			.694,
			0,
			.694
		],
		60177: [
			0,
			0,
			0
		],
		60178: [
			0,
			0,
			0
		],
		60182: [
			.626,
			.027,
			.5
		],
		60185: [
			-.111,
			.2,
			.278
		],
		60190: [
			.868,
			.212,
			.597
		],
		60191: [
			.694,
			.212,
			.444
		],
		60200: [
			.716,
			.022,
			1.111
		],
		60201: [
			.5,
			.226,
			.472
		],
		60203: [
			.79,
			.096,
			.667
		],
		60209: [
			.345,
			-.086,
			.341
		],
		60213: [
			.868,
			.212,
			.278,
			{ ic: .112 }
		],
		60214: [
			.694,
			.212,
			.239,
			{ ic: .058 }
		],
		60218: [
			.868,
			.022,
			.472,
			{ ic: .126 }
		],
		60219: [
			.694,
			.205,
			.267,
			{ ic: .058 }
		],
		60224: [
			.77,
			.047,
			1,
			{ ic: .012 }
		],
		60232: [
			.868,
			.212,
			.736
		],
		60233: [
			.694,
			.212,
			.5
		],
		60237: [
			.347,
			.056,
			.392
		],
		60257: [
			.399,
			-.265,
			.239,
			{ ic: .007 }
		],
		60259: [
			.639,
			-.477,
			.294,
			{ ic: .305 }
		],
		60261: [
			.692,
			-.568,
			.239,
			{ ic: .278 }
		],
		60270: [
			.694,
			.244,
			.688
		],
		60271: [
			.444,
			.244,
			.517
		],
		60424: [
			.855,
			0,
			.708
		],
		60425: [
			.855,
			0,
			.517
		],
		60426: [
			.855,
			0,
			.542
		],
		60427: [
			.855,
			0,
			.239,
			{ ic: .047 }
		],
		60428: [
			.855,
			0,
			.681
		],
		60429: [
			.732,
			.011,
			.361
		],
		60430: [
			.816,
			0,
			.681
		],
		60432: [
			.881,
			.186,
			.736
		],
		60433: [
			.631,
			.186,
			.5
		],
		61699: [
			.716,
			.022,
			1.111
		],
		61700: [
			.305,
			-.244,
			.667
		],
		61705: [
			.127,
			0,
			.611
		],
		61719: [
			.353,
			-.098,
			.239,
			{ ic: .016 }
		],
		61720: [
			.759,
			.055,
			.528
		],
		61721: [
			.753,
			.041,
			.444
		],
		61722: [
			.694,
			.217,
			.694
		],
		61723: [
			.445,
			.205,
			.537
		],
		61724: [
			.694,
			.195,
			.728
		],
		61725: [
			.694,
			.195,
			.891
		],
		61726: [
			.694,
			.195,
			.639
		],
		61729: [
			.445,
			.162,
			.539
		],
		61730: [
			.445,
			.162,
			.68
		],
		61731: [
			.455,
			.311,
			.517
		],
		61734: [
			.694,
			.195,
			.542
		],
		61735: [
			.716,
			.022,
			.639
		],
		61736: [
			.445,
			.162,
			.39
		],
		61737: [
			.461,
			.011,
			.444
		],
		61738: [
			.694,
			.217,
			.875
		],
		61739: [
			.694,
			.217,
			.639
		],
		61740: [
			.445,
			.205,
			.669
		],
		61741: [
			.455,
			.322,
			.517
		],
		61743: [
			.662,
			.179,
			.555
		],
		61747: [
			.694,
			0,
			.667
		],
		61748: [
			.822,
			0,
			.639
		],
		61749: [
			.455,
			.011,
			.633
		],
		61750: [
			.625,
			.011,
			.417
		],
		61751: [
			.005,
			.209,
			.139
		],
		61752: [
			.004,
			.205,
			.194,
			{ ic: .013 }
		],
		61757: [
			.722,
			-.526,
			.667,
			{ ic: .003 }
		],
		61761: [
			.695,
			-.528,
			.5
		],
		61762: [
			.695,
			-.528,
			.5
		],
		61763: [
			.283,
			-.031,
			.444
		],
		61764: [
			.283,
			-.031,
			.444
		],
		61765: [
			.695,
			-.4,
			.333
		],
		61766: [
			.678,
			-.41,
			.222,
			{ ic: .067 }
		],
		61771: [
			.039,
			.039,
			.333,
			{ ic: .038 }
		],
		61772: [
			.212,
			.039,
			.333,
			{ ic: .038 }
		],
		61773: [
			.386,
			.039,
			.333,
			{ ic: .038 }
		],
		61774: [
			.56,
			.039,
			.333,
			{ ic: .038 }
		],
		61775: [
			.733,
			.039,
			.333,
			{ ic: .038 }
		],
		61776: [
			.212,
			.039,
			.333,
			{ ic: .038 }
		],
		61777: [
			.386,
			.039,
			.333,
			{ ic: .038 }
		],
		61778: [
			.56,
			.039,
			.333,
			{ ic: .039 }
		],
		61779: [
			.733,
			.039,
			.333,
			{ ic: .039 }
		],
		61780: [
			.039,
			.039,
			.222,
			{ ic: .039 }
		],
		61781: [
			.212,
			.039,
			.222,
			{ ic: .039 }
		],
		61782: [
			.386,
			.039,
			.222,
			{ ic: .038 }
		],
		61783: [
			.56,
			.039,
			.222,
			{ ic: .039 }
		],
		61784: [
			.733,
			.039,
			.222,
			{ ic: .039 }
		],
		61785: [
			.212,
			.039,
			.222,
			{ ic: .039 }
		],
		61786: [
			.386,
			.039,
			.222,
			{ ic: .039 }
		],
		61787: [
			.56,
			.039,
			.222,
			{ ic: .039 }
		],
		61788: [
			.733,
			.039,
			.222,
			{ ic: .039 }
		],
		61791: [
			.695,
			-.488,
			.5
		],
		61792: [
			.695,
			-.488,
			.5
		],
		61793: [
			.695,
			-.528,
			.5
		],
		61794: [
			.695,
			-.528,
			.5
		],
		61795: [
			.695,
			-.528,
			.5
		],
		61796: [
			.695,
			-.528,
			.5
		],
		61797: [
			.455,
			.195,
			.314
		],
		61800: [
			.461,
			.016,
			.722
		],
		61804: [
			.445,
			.205,
			.267,
			{ ic: .002 }
		],
		61805: [
			.028,
			.206,
			.333
		],
		61806: [
			.1,
			.217,
			.222,
			{ ic: .069 }
		],
		61807: [
			.1,
			.217,
			.222
		],
		61808: [
			.1,
			.217,
			.278
		],
		61809: [
			.684,
			-.445,
			.339
		],
		61810: [
			.732,
			-.482,
			.444
		],
		61813: [
			.455,
			.011,
			.517
		],
		61817: [
			.711,
			.22,
			.5
		],
		61818: [
			.461,
			.22,
			.444
		],
		61819: [
			.695,
			.011,
			.697
		],
		61822: [
			.455,
			.217,
			.556
		],
		61823: [
			.455,
			.217,
			.556
		],
		61824: [
			.717,
			.217,
			.536,
			{ ic: .055 }
		],
		61826: [
			.68,
			.205,
			.331
		],
		61828: [
			.695,
			0,
			.794
		],
		61829: [
			.455,
			0,
			.628
		],
		61832: [
			.455,
			.002,
			.611
		],
		61833: [
			.455,
			.217,
			.544
		],
		61834: [
			.571,
			.011,
			.528
		],
		61835: [
			.455,
			.254,
			.361
		],
		61836: [
			.445,
			.233,
			.5
		],
		61837: [
			.467,
			.233,
			.5
		],
		61838: [
			.695,
			.067,
			.5
		],
		61839: [
			.695,
			.011,
			.5
		],
		61842: [
			.695,
			0,
			.342
		],
		61850: [
			.445,
			0,
			.463
		],
		61854: [
			.445,
			0,
			.483
		],
		61855: [
			.445,
			0,
			.372
		],
		61857: [
			.459,
			0,
			.484
		],
		61859: [
			.717,
			-.528,
			.5
		],
		61860: [
			.717,
			-.528,
			.5
		],
		61863: [
			.011,
			.217,
			.222
		],
		61864: [
			.011,
			.217,
			.222,
			{ ic: .069 }
		],
		61865: [
			-.111,
			.295,
			.5
		],
		61866: [
			-.094,
			.303,
			.5
		],
		61867: [
			.272,
			-.216,
			.278
		],
		61868: [
			.353,
			-.098,
			.239
		],
		61869: [
			-.111,
			.295,
			.5
		],
		61870: [
			-.111,
			.325,
			.5
		],
		61871: [
			-.101,
			.266,
			.5
		],
		61872: [
			-.025,
			.275,
			.556
		],
		61873: [
			.661,
			-.467,
			.555
		],
		61874: [
			.738,
			-.508,
			.5
		],
		61875: [
			.738,
			-.508,
			.5
		],
		61876: [
			.802,
			.302,
			1.111
		],
		61877: [
			.854,
			.354,
			1.111
		],
		62082: [
			.07,
			0,
			.278
		],
		62083: [
			.728,
			-.511,
			.5
		],
		62110: [
			.733,
			-.508,
			.5
		],
		62113: [
			.694,
			.022,
			.639
		],
		62116: [
			.694,
			0,
			.694
		],
		62119: [
			.694,
			0,
			.694
		],
		62120: [
			.694,
			.195,
			1.091
		],
		62121: [
			.445,
			.011,
			.48
		],
		62124: [
			.445,
			0,
			.537
		],
		62126: [
			.445,
			0,
			.537
		],
		62127: [
			.445,
			.162,
			.76
		],
		62560: [
			.85,
			0,
			.667
		],
		62561: [
			.857,
			0,
			.597
		],
		62562: [
			.857,
			0,
			.694
		],
		62563: [
			.85,
			.022,
			.736
		],
		62564: [
			.857,
			0,
			.667
		],
		62565: [
			.857,
			0,
			.889
		],
		62566: [
			.857,
			.022,
			.639
		],
		62567: [
			.857,
			.022,
			1.041
		],
		62568: [
			.857,
			0,
			.646
		],
		62570: [
			.64,
			.011,
			.48
		],
		62571: [
			.64,
			.011,
			.444
		],
		62572: [
			.641,
			0,
			.537
		],
		62573: [
			.64,
			.011,
			.5
		],
		62574: [
			.641,
			.205,
			.461
		],
		62575: [
			.641,
			0,
			.683
		],
		62576: [
			.641,
			.011,
			.444
		],
		62577: [
			.641,
			.011,
			.73
		],
		62578: [
			.641,
			0,
			.515
		],
		63166: [
			.444,
			.205,
			.267
		],
		63187: [
			.851,
			-.76,
			.5,
			{ ic: .027 }
		],
		63188: [
			.639,
			-.5,
			.5
		],
		63189: [
			.65,
			-.51,
			.5
		],
		63190: [
			.64,
			-.51,
			.5
		],
		63198: [
			.305,
			-.244,
			.75
		],
		8592: [
			.511,
			.009,
			1
		],
		8593: [
			.711,
			.195,
			.5
		],
		8594: [
			.511,
			.009,
			1
		],
		8595: [
			.694,
			.211,
			.5
		],
		8730: [
			.763,
			.104,
			.472,
			{ ic: .05 }
		],
		8738: [
			.583,
			.083,
			.778
		],
		9001: [
			.751,
			.249,
			.389
		],
		9002: [
			.751,
			.249,
			.389
		],
		9702: [
			.407,
			-.121,
			.778
		],
		10214: [
			.751,
			.249,
			.403
		],
		10215: [
			.751,
			.249,
			.403
		]
	} },
	SSBX: { "bold-sans-serif": {
		161: [
			.5,
			.194,
			.367
		],
		162: [
			.548,
			.089,
			.459
		],
		164: [
			.541,
			.041,
			.856
		],
		166: [
			.75,
			.25,
			.319
		],
		169: [
			.694,
			0,
			.694
		],
		170: [
			.715,
			-.276,
			.416
		],
		171: [
			.5,
			0,
			.55
		],
		173: [
			.265,
			-.193,
			.367
		],
		174: [
			.694,
			0,
			.694
		],
		186: [
			.684,
			-.278,
			.461
		],
		187: [
			.5,
			0,
			.55
		],
		188: [
			.739,
			.037,
			.88
		],
		189: [
			.739,
			.037,
			.978
		],
		190: [
			.739,
			.037,
			.88
		],
		191: [
			.528,
			.178,
			.519
		],
		3647: [
			.794,
			.1,
			.733
		],
		8218: [
			.129,
			.113,
			.306
		],
		8219: [
			.695,
			-.453,
			.306
		],
		8222: [
			.129,
			.113,
			.529
		],
		8223: [
			.722,
			-.48,
			.61
		],
		8226: [
			.418,
			-.114,
			.856
		],
		8233: [
			.722,
			.194,
			.519
		],
		8240: [
			.773,
			.079,
			1.4
		],
		8241: [
			.773,
			.079,
			1.845
		],
		8249: [
			.5,
			0,
			.319
		],
		8250: [
			.5,
			0,
			.319
		],
		8251: [
			.541,
			.04,
			.856
		],
		8253: [
			.743,
			0,
			.487
		],
		8255: [
			-.063,
			.194,
			.649
		],
		8256: [
			.696,
			-.565,
			.649
		],
		8261: [
			.751,
			.252,
			.397
		],
		8262: [
			.751,
			.252,
			.397
		],
		8274: [
			.768,
			.016,
			.55
		],
		8276: [
			-.063,
			.194,
			.649
		],
		8319: [
			.587,
			-.305,
			.336
		],
		8320: [
			.361,
			.03,
			.489
		],
		8353: [
			.885,
			.193,
			.703
		],
		8358: [
			.694,
			0,
			.794
		],
		8361: [
			.694,
			0,
			1.039
		],
		8363: [
			.654,
			.168,
			.561
		],
		8369: [
			.694,
			0,
			.703
		],
		8370: [
			.887,
			.191,
			.733
		],
		8451: [
			.706,
			.011,
			1.053
		],
		8470: [
			.694,
			0,
			.959
		],
		8471: [
			.694,
			0,
			.694
		],
		8478: [
			.694,
			0,
			.703
		],
		8480: [
			.711,
			-.27,
			.869
		],
		8482: [
			.698,
			-.28,
			.952
		],
		8494: [
			.712,
			.01,
			.758
		],
		8960: [
			.636,
			.135,
			.856
		],
		9250: [
			.653,
			.01,
			.627
		],
		9251: [
			.276,
			.122,
			.55
		],
		11800: [
			.529,
			.214,
			.487
		],
		64256: [
			.706,
			0,
			.642,
			{ ic: .042 }
		],
		64257: [
			.706,
			0,
			.586
		],
		64258: [
			.706,
			0,
			.586
		],
		64259: [
			.706,
			0,
			.892
		],
		64260: [
			.706,
			0,
			.892
		],
		65126: [
			.354,
			-.053,
			.367
		],
		184: [
			-.023,
			.194,
			.489
		],
		688: [
			.73,
			-.306,
			.336
		],
		689: [
			.772,
			-.306,
			.336
		],
		690: [
			.717,
			-.183,
			.173
		],
		691: [
			.601,
			-.305,
			.223
		],
		692: [
			.601,
			-.305,
			.223
		],
		693: [
			.58,
			-.159,
			.223,
			{ ic: .071 }
		],
		694: [
			.597,
			-.299,
			.33
		],
		695: [
			.593,
			-.305,
			.446
		],
		696: [
			.581,
			-.184,
			.3
		],
		697: [
			.695,
			-.507,
			.183,
			{ ic: .01 }
		],
		698: [
			.695,
			-.507,
			.423
		],
		699: [
			.722,
			-.48,
			.305
		],
		700: [
			.722,
			-.48,
			.305
		],
		701: [
			.695,
			-.453,
			.306
		],
		702: [
			.63,
			-.268,
			.436
		],
		703: [
			.63,
			-.268,
			.436
		],
		704: [
			.761,
			-.496,
			.489
		],
		705: [
			.761,
			-.496,
			.489
		],
		706: [
			.737,
			-.487,
			.367
		],
		707: [
			.737,
			-.487,
			.367
		],
		708: [
			.694,
			-.546,
			.55
		],
		709: [
			.661,
			-.513,
			.55
		],
		712: [
			.694,
			-.451,
			.244
		],
		716: [
			.049,
			.194,
			.244
		],
		718: [
			-.132,
			.287,
			.55
		],
		719: [
			-.136,
			.288,
			.55
		],
		720: [
			.458,
			.003,
			.306
		],
		721: [
			.458,
			-.281,
			.306
		],
		722: [
			.454,
			-.15,
			.367
		],
		723: [
			.454,
			-.15,
			.367
		],
		724: [
			.317,
			-.065,
			.489
		],
		725: [
			.317,
			-.065,
			.489
		],
		726: [
			.313,
			-.004,
			.489
		],
		727: [
			.275,
			-.183,
			.489
		],
		731: [
			.018,
			.213,
			.55
		],
		733: [
			.694,
			-.546,
			.55
		],
		734: [
			.463,
			-.214,
			.367,
			{ ic: .022 }
		],
		735: [
			.672,
			-.462,
			.55
		],
		736: [
			.58,
			-.174,
			.3
		],
		737: [
			.738,
			-.305,
			.153
		],
		738: [
			.59,
			-.298,
			.253
		],
		739: [
			.58,
			-.305,
			.3
		],
		740: [
			.729,
			-.305,
			.33
		],
		741: [
			.716,
			.022,
			.367,
			{ ic: .067 }
		],
		742: [
			.717,
			.022,
			.367,
			{ ic: .067 }
		],
		743: [
			.717,
			.022,
			.367,
			{ ic: .067 }
		],
		744: [
			.717,
			.022,
			.367,
			{ ic: .067 }
		],
		745: [
			.716,
			.022,
			.367,
			{ ic: .067 }
		],
		746: [
			.716,
			-.228,
			.367,
			{ ic: .067 }
		],
		747: [
			.717,
			.022,
			.367,
			{ ic: .067 }
		],
		748: [
			-.042,
			.19,
			.55
		],
		749: [
			.767,
			-.532,
			.55
		],
		750: [
			.722,
			-.48,
			.505
		],
		751: [
			0,
			.228,
			.556,
			{ ic: .005 }
		],
		752: [
			0,
			.228,
			.556,
			{ ic: .005 }
		],
		753: [
			-.041,
			.291,
			.367
		],
		754: [
			-.041,
			.291,
			.367
		],
		755: [
			-.041,
			.224,
			.223
		],
		756: [
			.314,
			-.167,
			.436
		],
		757: [
			.314,
			-.167,
			.554
		],
		758: [
			.314,
			-.167,
			.554
		],
		759: [
			-.042,
			.169,
			.55
		],
		760: [
			.544,
			-.203,
			.306
		],
		761: [
			.672,
			-.431,
			.318
		],
		762: [
			.672,
			-.431,
			.318
		],
		763: [
			.129,
			.112,
			.318
		],
		764: [
			.129,
			.112,
			.318
		],
		765: [
			.129,
			.112,
			.558
		],
		766: [
			.129,
			.112,
			.558
		],
		777: [
			.72,
			-.513,
			0,
			{ dx: .263 }
		],
		779: [
			.695,
			-.507,
			0,
			{ dx: .229 }
		],
		781: [
			.717,
			-.529,
			0,
			{ dx: .273 }
		],
		782: [
			.717,
			-.529,
			0,
			{ dx: .276 }
		],
		783: [
			.695,
			-.507,
			0,
			{ dx: .291 }
		],
		784: [
			.817,
			-.533,
			.256
		],
		785: [
			.685,
			-.513,
			.256
		],
		786: [
			.722,
			-.48,
			.305
		],
		787: [
			.692,
			-.45,
			0,
			{ dx: .111 }
		],
		788: [
			.692,
			-.45,
			0,
			{ dx: .111 }
		],
		789: [
			.866,
			-.624,
			0,
			{ dx: .006 }
		],
		790: [
			-.136,
			.283,
			0,
			{ dx: .323 }
		],
		791: [
			-.136,
			.284,
			0,
			{ dx: .222 }
		],
		792: [
			-.066,
			.38,
			.489
		],
		793: [
			-.066,
			.38,
			.489
		],
		794: [
			.806,
			-.565,
			.18,
			{ ic: .034 }
		],
		795: [
			.692,
			-.45,
			0,
			{ dx: .111 }
		],
		796: [
			-.042,
			.346,
			0,
			{ dx: .197 }
		],
		797: [
			-.095,
			.317,
			0,
			{ dx: .245 }
		],
		798: [
			-.063,
			.285,
			0,
			{ dx: .245 }
		],
		799: [
			-.066,
			.375,
			0,
			{ dx: .245 }
		],
		800: [
			-.059,
			.144,
			0,
			{ dx: .247 }
		],
		801: [
			.024,
			.217,
			0,
			{ dx: .204 }
		],
		802: [
			.024,
			.217,
			0,
			{ dx: .204 }
		],
		803: [
			-.09,
			.195,
			0,
			{ dx: .262 }
		],
		804: [
			-.09,
			.195,
			0,
			{ dx: .276 }
		],
		805: [
			-.058,
			.241,
			.223
		],
		806: [
			-.066,
			.308,
			0,
			{ dx: .265 }
		],
		807: [
			-.023,
			.194,
			0,
			{ dx: .293 }
		],
		808: [
			.008,
			.223,
			0,
			{ dx: .192 }
		],
		809: [
			-.063,
			.306,
			0,
			{ dx: .122 }
		],
		810: [
			-.111,
			.297,
			0,
			{ dx: .276 }
		],
		811: [
			-.112,
			.308,
			0,
			{ dx: .276 }
		],
		812: [
			-.062,
			.21,
			0,
			{ dx: .256 }
		],
		813: [
			-.062,
			.21,
			0,
			{ dx: .256 }
		],
		814: [
			-.041,
			.213,
			0,
			{ dx: .262 }
		],
		815: [
			-.041,
			.213,
			0,
			{ dx: .262 }
		],
		816: [
			-.08,
			.207,
			0,
			{ dx: .262 }
		],
		817: [
			-.099,
			.184,
			0,
			{ dx: .262 }
		],
		818: [
			-.099,
			.184,
			0,
			{ dx: .262 }
		],
		819: [
			-.042,
			.267,
			0,
			{ dx: .262 }
		],
		820: [
			.333,
			-.206,
			0
		],
		821: [
			.284,
			-.219,
			0
		],
		822: [
			.284,
			-.219,
			0
		],
		823: [
			.448,
			-.12,
			0
		],
		825: [
			-.042,
			.346,
			0,
			{ dx: .172 }
		],
		826: [
			-.115,
			.301,
			0,
			{ dx: .276 }
		],
		827: [
			-.111,
			.337,
			0,
			{ dx: .276 }
		],
		828: [
			-.1,
			.233,
			0,
			{ dx: .276 }
		],
		829: [
			.672,
			-.462,
			0,
			{ dx: .276 }
		],
		830: [
			.864,
			-.498,
			.209
		],
		831: [
			.772,
			-.537,
			.855
		],
		832: [
			.684,
			-.537,
			.55
		],
		833: [
			.685,
			-.537,
			.55
		],
		834: [
			.65,
			-.52,
			.633
		],
		835: [
			.694,
			-.511,
			.222
		],
		836: [
			.694,
			-.508,
			.278,
			{ ic: .04 }
		],
		837: [
			-.068,
			.257,
			.11
		],
		838: [
			.698,
			-.512,
			0,
			{ dx: .276 }
		],
		839: [
			-.071,
			.373,
			0,
			{ dx: .209 }
		],
		840: [
			-.143,
			.323,
			0,
			{ dx: .276 }
		],
		841: [
			-.067,
			.308,
			0,
			{ dx: .182 }
		],
		842: [
			.771,
			-.474,
			.55
		],
		843: [
			.797,
			-.465,
			.55
		],
		844: [
			.837,
			-.503,
			.556
		],
		845: [
			-.025,
			.319,
			0,
			{ dx: .309 }
		],
		846: [
			-.031,
			.313,
			0,
			{ dx: .299 }
		],
		848: [
			.789,
			-.495,
			.278
		],
		849: [
			.689,
			-.506,
			.223
		],
		850: [
			.817,
			-.533,
			.256
		],
		851: [
			-.085,
			.356,
			0,
			{ dx: .245 }
		],
		852: [
			-.017,
			.311,
			0,
			{ dx: .311 }
		],
		853: [
			-.017,
			.311,
			0,
			{ dx: .311 }
		],
		854: [
			-.017,
			.311,
			0,
			{ dx: .162 }
		],
		855: [
			.689,
			-.506,
			.223
		],
		856: [
			.672,
			-.567,
			0,
			{ dx: .052 }
		],
		857: [
			-.041,
			.287,
			.317
		],
		858: [
			-.041,
			.224,
			.369
		],
		859: [
			.757,
			-.451,
			.5
		],
		860: [
			-.152,
			.431,
			0,
			{ dx: .341 }
		],
		861: [
			.765,
			-.486,
			0,
			{ dx: -.035 }
		],
		862: [
			.633,
			-.548,
			0,
			{ dx: .011 }
		],
		863: [
			-.099,
			.184,
			0,
			{ dx: .001 }
		],
		864: [
			.722,
			-.562,
			0,
			{ dx: 0 }
		],
		865: [
			.666,
			-.387,
			0
		],
		866: [
			-.011,
			.334,
			0,
			{ dx: .001 }
		],
		867: [
			.712,
			-.474,
			.294
		],
		868: [
			.715,
			-.477,
			.289
		],
		869: [
			.803,
			-.476,
			.13
		],
		870: [
			.714,
			-.476,
			.296
		],
		871: [
			.705,
			-.475,
			.267
		],
		872: [
			.712,
			-.474,
			.255
		],
		873: [
			.807,
			-.472,
			.273
		],
		874: [
			.809,
			-.478,
			.258
		],
		875: [
			.709,
			-.478,
			.442
		],
		876: [
			.708,
			-.478,
			.23
		],
		877: [
			.768,
			-.472,
			.222
		],
		878: [
			.703,
			-.476,
			.294
		],
		879: [
			.705,
			-.478,
			.32
		],
		7620: [
			.695,
			-.486,
			0,
			{ dx: .242 }
		],
		7621: [
			.695,
			-.486,
			0,
			{ dx: .308 }
		],
		7624: [
			.695,
			-.537,
			0,
			{ dx: .276 }
		],
		7625: [
			.695,
			-.537,
			0,
			{ dx: .276 }
		],
		9474: [
			.752,
			.253,
			.306
		],
		9553: [
			.752,
			.253,
			.531
		],
		9773: [
			.593,
			.001,
			.7
		],
		9792: [
			.48,
			.217,
			.55
		],
		9834: [
			.724,
			.052,
			.672
		],
		9901: [
			.484,
			-.022,
			.67
		],
		9902: [
			.629,
			.127,
			1.249
		],
		9906: [
			.48,
			.217,
			.55
		],
		10013: [
			.632,
			.028,
			.55
		],
		59395: [
			.706,
			0,
			.867
		],
		59908: [
			.866,
			-.519,
			.55
		],
		59909: [
			-.071,
			.213,
			.55
		],
		59910: [
			-.071,
			.213,
			.55
		],
		59913: [
			.866,
			-.545,
			.55
		],
		59915: [
			.923,
			-.545,
			.55
		],
		59917: [
			.687,
			-.545,
			.55
		],
		59920: [
			.888,
			-.545,
			.55
		],
		59927: [
			.841,
			-.535,
			.55
		],
		59930: [
			.841,
			-.535,
			.55
		],
		59932: [
			.898,
			-.535,
			.55
		],
		59934: [
			.863,
			-.535,
			.55
		],
		59935: [
			-.079,
			.292,
			.55
		],
		59942: [
			.694,
			-.537,
			.55
		],
		59946: [
			.858,
			-.564,
			.55
		],
		59948: [
			.846,
			-.564,
			.55
		],
		59951: [
			.858,
			-.564,
			.55
		],
		59957: [
			.719,
			-.513,
			.55
		],
		59962: [
			-.099,
			.184,
			.55
		],
		59966: [
			-.099,
			.184,
			.55
		],
		59970: [
			.863,
			-.526,
			.733
		],
		59973: [
			-.076,
			.207,
			.55
		],
		60163: [
			.885,
			.213,
			.733,
			{ ic: .003 }
		],
		60164: [
			.694,
			.213,
			.525
		],
		60168: [
			.694,
			0,
			.694
		],
		60175: [
			.694,
			0,
			.694
		],
		60176: [
			0,
			0,
			0
		],
		60177: [
			0,
			0,
			0
		],
		60178: [
			0,
			0,
			0
		],
		60182: [
			.631,
			.025,
			.55
		],
		60185: [
			-.085,
			.2,
			.306
		],
		60190: [
			.885,
			.213,
			.642
		],
		60191: [
			.694,
			.213,
			.511
		],
		60200: [
			.716,
			.022,
			1.222
		],
		60201: [
			.5,
			.244,
			.519
		],
		60203: [
			.844,
			.15,
			.733
		],
		60209: [
			.356,
			-.053,
			.367
		],
		60213: [
			.885,
			.213,
			.331,
			{ ic: .078 }
		],
		60214: [
			.694,
			.213,
			.256,
			{ ic: .039 }
		],
		60218: [
			.885,
			.022,
			.519,
			{ ic: .081 }
		],
		60219: [
			.694,
			.205,
			.286,
			{ ic: .039 }
		],
		60224: [
			.797,
			.073,
			1.1,
			{ ic: .024 }
		],
		60232: [
			.885,
			.213,
			.794
		],
		60233: [
			.694,
			.213,
			.55
		],
		60237: [
			.347,
			.056,
			.485
		],
		60257: [
			.416,
			-.292,
			.256,
			{ ic: .061 }
		],
		60259: [
			.667,
			-.486,
			.336,
			{ ic: .367 }
		],
		60261: [
			.694,
			-.563,
			.256,
			{ ic: .334 }
		],
		60270: [
			.694,
			.213,
			.764
		],
		60271: [
			.458,
			.213,
			.561
		],
		60424: [
			.877,
			0,
			.794
		],
		60425: [
			.877,
			0,
			.561
		],
		60426: [
			.877,
			0,
			.581
		],
		60427: [
			.877,
			0,
			.256,
			{ ic: .055 }
		],
		60428: [
			.877,
			0,
			.733
		],
		60429: [
			.772,
			.011,
			.404
		],
		60430: [
			.849,
			0,
			.733
		],
		60432: [
			.889,
			.194,
			.794
		],
		60433: [
			.653,
			.194,
			.55
		],
		61699: [
			.717,
			.022,
			1.222
		],
		61700: [
			.32,
			-.247,
			.733
		],
		61705: [
			.131,
			0,
			.672
		],
		61719: [
			.419,
			-.119,
			.255,
			{ ic: .043 }
		],
		61720: [
			.779,
			.05,
			.55
		],
		61721: [
			.761,
			.035,
			.489
		],
		61722: [
			.694,
			.217,
			.764
		],
		61723: [
			.458,
			.206,
			.592
		],
		61724: [
			.694,
			.195,
			.844
		],
		61725: [
			.694,
			.195,
			1.018
		],
		61726: [
			.694,
			.195,
			.703
		],
		61729: [
			.458,
			.162,
			.636
		],
		61730: [
			.458,
			.162,
			.782
		],
		61731: [
			.469,
			.311,
			.561
		],
		61734: [
			.694,
			.195,
			.58
		],
		61735: [
			.717,
			.022,
			.703
		],
		61736: [
			.458,
			.162,
			.418
		],
		61737: [
			.475,
			.013,
			.489
		],
		61738: [
			.694,
			.217,
			.978
		],
		61739: [
			.694,
			.217,
			.703
		],
		61740: [
			.458,
			.206,
			.744
		],
		61741: [
			.469,
			.322,
			.561
		],
		61743: [
			.811,
			.285,
			.611
		],
		61747: [
			.694,
			.002,
			.733
		],
		61748: [
			.871,
			0,
			.703
		],
		61749: [
			.471,
			.011,
			.696,
			{ ic: .023 }
		],
		61750: [
			.638,
			.011,
			.458
		],
		61751: [
			-.001,
			.226,
			.153
		],
		61752: [
			0,
			.216,
			.214,
			{ ic: .025 }
		],
		61757: [
			.722,
			-.521,
			.733
		],
		61761: [
			.695,
			-.537,
			.55
		],
		61762: [
			.695,
			-.537,
			.55
		],
		61763: [
			.316,
			-.001,
			.489
		],
		61764: [
			.316,
			-.001,
			.489
		],
		61765: [
			.695,
			-.412,
			.367
		],
		61766: [
			.684,
			-.389,
			.244,
			{ ic: .074 }
		],
		61771: [
			.068,
			.068,
			.367,
			{ ic: .067 }
		],
		61772: [
			.242,
			.068,
			.367,
			{ ic: .067 }
		],
		61773: [
			.415,
			.068,
			.367,
			{ ic: .067 }
		],
		61774: [
			.589,
			.068,
			.367,
			{ ic: .067 }
		],
		61775: [
			.762,
			.068,
			.367,
			{ ic: .067 }
		],
		61776: [
			.242,
			.068,
			.367,
			{ ic: .067 }
		],
		61777: [
			.415,
			.068,
			.367,
			{ ic: .067 }
		],
		61778: [
			.589,
			.068,
			.367,
			{ ic: .067 }
		],
		61779: [
			.762,
			.068,
			.367,
			{ ic: .067 }
		],
		61780: [
			.068,
			.068,
			.244,
			{ ic: .068 }
		],
		61781: [
			.242,
			.068,
			.244,
			{ ic: .068 }
		],
		61782: [
			.415,
			.068,
			.244,
			{ ic: .068 }
		],
		61783: [
			.589,
			.068,
			.244,
			{ ic: .068 }
		],
		61784: [
			.762,
			.068,
			.244,
			{ ic: .068 }
		],
		61785: [
			.242,
			.068,
			.244,
			{ ic: .068 }
		],
		61786: [
			.415,
			.068,
			.244,
			{ ic: .068 }
		],
		61787: [
			.589,
			.068,
			.244,
			{ ic: .068 }
		],
		61788: [
			.763,
			.068,
			.244,
			{ ic: .068 }
		],
		61791: [
			.695,
			-.478,
			.55
		],
		61792: [
			.695,
			-.486,
			.55
		],
		61793: [
			.695,
			-.536,
			.55
		],
		61794: [
			.695,
			-.536,
			.55
		],
		61795: [
			.695,
			-.531,
			.55
		],
		61796: [
			.695,
			-.531,
			.55
		],
		61797: [
			.469,
			.195,
			.342
		],
		61800: [
			.475,
			.016,
			.794
		],
		61804: [
			.458,
			.205,
			.286,
			{ ic: .009 }
		],
		61805: [
			.032,
			.206,
			.367
		],
		61806: [
			.116,
			.217,
			.244,
			{ ic: .074 }
		],
		61807: [
			.116,
			.217,
			.244
		],
		61808: [
			.115,
			.217,
			.306
		],
		61809: [
			.684,
			-.458,
			.378
		],
		61810: [
			.816,
			-.494,
			.489
		],
		61813: [
			.469,
			.011,
			.561
		],
		61817: [
			.711,
			.223,
			.55
		],
		61818: [
			.475,
			.223,
			.489
		],
		61819: [
			.695,
			.011,
			.76
		],
		61822: [
			.469,
			.217,
			.611
		],
		61823: [
			.469,
			.217,
			.611
		],
		61824: [
			.717,
			.217,
			.586,
			{ ic: .059 }
		],
		61826: [
			.696,
			.206,
			.36
		],
		61828: [
			.695,
			0,
			.867
		],
		61829: [
			.469,
			0,
			.683
		],
		61832: [
			.469,
			.011,
			.672
		],
		61833: [
			.469,
			.217,
			.592
		],
		61834: [
			.59,
			.011,
			.588
		],
		61835: [
			.469,
			.249,
			.404
		],
		61836: [
			.458,
			.258,
			.55
		],
		61837: [
			.48,
			.258,
			.55
		],
		61838: [
			.695,
			.069,
			.55
		],
		61839: [
			.695,
			.011,
			.55
		],
		61842: [
			.695,
			0,
			.372
		],
		61850: [
			.458,
			.002,
			.574
		],
		61854: [
			.459,
			0,
			.598
		],
		61855: [
			.458,
			0,
			.448
		],
		61857: [
			.474,
			.003,
			.604
		],
		61859: [
			.717,
			-.537,
			.55
		],
		61860: [
			.717,
			-.537,
			.55
		],
		61863: [
			.024,
			.217,
			.244
		],
		61864: [
			.024,
			.217,
			.244,
			{ ic: .074 }
		],
		61865: [
			-.111,
			.3,
			.55
		],
		61866: [
			-.112,
			.308,
			.55
		],
		61867: [
			.284,
			-.22,
			.305
		],
		61868: [
			.419,
			-.119,
			.255
		],
		61869: [
			-.112,
			.301,
			.55
		],
		61870: [
			-.111,
			.337,
			.55
		],
		61871: [
			-.1,
			.233,
			.55
		],
		61872: [
			-.011,
			.334,
			.611
		],
		61873: [
			.689,
			-.481,
			.611
		],
		61874: [
			.752,
			-.53,
			.55
		],
		61875: [
			.752,
			-.53,
			.55
		],
		61876: [
			.835,
			.335,
			1.222
		],
		61877: [
			.94,
			.44,
			1.222
		],
		62082: [
			.112,
			.001,
			.305
		],
		62083: [
			.735,
			-.528,
			.55
		],
		62110: [
			.747,
			-.53,
			.55
		],
		62113: [
			.694,
			.022,
			.703
		],
		62116: [
			.694,
			0,
			.764
		],
		62119: [
			.694,
			0,
			.764
		],
		62120: [
			.694,
			.194,
			1.223
		],
		62121: [
			.458,
			.011,
			.525
		],
		62124: [
			.458,
			0,
			.592
		],
		62126: [
			.458,
			0,
			.592
		],
		62127: [
			.458,
			.162,
			.836
		],
		62560: [
			.912,
			0,
			.733
		],
		62561: [
			.912,
			0,
			.642
		],
		62562: [
			.912,
			0,
			.764
		],
		62563: [
			.912,
			.022,
			.794
		],
		62564: [
			.912,
			0,
			.733
		],
		62565: [
			.912,
			0,
			.978
		],
		62566: [
			.912,
			.022,
			.703
		],
		62567: [
			.912,
			.022,
			1.14
		],
		62568: [
			.912,
			0,
			.703
		],
		62570: [
			.668,
			.01,
			.493
		],
		62571: [
			.668,
			.01,
			.48
		],
		62572: [
			.668,
			0,
			.592
		],
		62573: [
			.668,
			.01,
			.517
		],
		62574: [
			.661,
			.167,
			.47
		],
		62575: [
			.661,
			0,
			.744
		],
		62576: [
			.668,
			.011,
			.489
		],
		62577: [
			.668,
			.011,
			.8
		],
		62578: [
			.661,
			0,
			.555
		],
		63166: [
			.522,
			.033,
			.391
		],
		63187: [
			.878,
			-.763,
			.55,
			{ ic: .026 }
		],
		63188: [
			.666,
			-.52,
			.55
		],
		63189: [
			.678,
			-.529,
			.55
		],
		63190: [
			.68,
			-.528,
			.55
		],
		63198: [
			.319,
			-.247,
			.825
		],
		8592: [
			.548,
			.046,
			1.1
		],
		8593: [
			.668,
			.194,
			.622
		],
		8594: [
			.548,
			.046,
			1.1
		],
		8595: [
			.668,
			.194,
			.622
		],
		8730: [
			.807,
			.082,
			.519,
			{ ic: .078 }
		],
		8738: [
			.634,
			.134,
			.856
		],
		9001: [
			.761,
			.262,
			.428
		],
		9002: [
			.761,
			.262,
			.428
		],
		9702: [
			.418,
			-.114,
			.856
		],
		10214: [
			.75,
			.222,
			.545
		],
		10215: [
			.75,
			.222,
			.545
		]
	} },
	SSIX: { "sans-serif-italic": {
		161: [
			.5,
			.194,
			.319
		],
		162: [
			.508,
			.064,
			.444,
			{ ic: .056 }
		],
		164: [
			.492,
			-.01,
			.778
		],
		166: [
			.75,
			.25,
			.278,
			{ ic: .038 }
		],
		169: [
			.694,
			0,
			.694,
			{ ic: .089 }
		],
		170: [
			.716,
			-.311,
			.372,
			{ ic: .093 }
		],
		171: [
			.439,
			0,
			.5,
			{ ic: .04 }
		],
		173: [
			.251,
			-.193,
			.333
		],
		174: [
			.694,
			0,
			.694,
			{ ic: .089 }
		],
		186: [
			.716,
			-.311,
			.419,
			{ ic: .095 }
		],
		187: [
			.439,
			0,
			.5
		],
		188: [
			.716,
			0,
			.788,
			{ ic: .016 }
		],
		189: [
			.716,
			0,
			.788
		],
		190: [
			.716,
			0,
			.788,
			{ ic: .016 }
		],
		191: [
			.5,
			.205,
			.472
		],
		3647: [
			.758,
			.064,
			.667,
			{ ic: .03 }
		],
		8218: [
			.084,
			.124,
			.278
		],
		8219: [
			.722,
			-.514,
			.278,
			{ ic: .058 }
		],
		8222: [
			.084,
			.124,
			.472
		],
		8223: [
			.722,
			-.514,
			.333,
			{ ic: .137 }
		],
		8226: [
			.407,
			-.121,
			.778
		],
		8233: [
			.722,
			.194,
			.472,
			{ ic: .12 }
		],
		8240: [
			.75,
			.056,
			1.154
		],
		8241: [
			.75,
			.056,
			1.471
		],
		8249: [
			.439,
			0,
			.333,
			{ ic: .04 }
		],
		8250: [
			.439,
			0,
			.333
		],
		8251: [
			.492,
			-.009,
			.778
		],
		8253: [
			.726,
			0,
			.472,
			{ ic: .051 }
		],
		8255: [
			.345,
			-.086,
			.333,
			{ ic: .018 }
		],
		8256: [
			.692,
			-.568,
			.597,
			{ ic: .049 }
		],
		8261: [
			.751,
			.309,
			.361,
			{ ic: .108 }
		],
		8262: [
			.751,
			.249,
			.361,
			{ ic: .066 }
		],
		8274: [
			.751,
			-.001,
			.5,
			{ ic: .103 }
		],
		8276: [
			-.07,
			.194,
			.597
		],
		8319: [
			.571,
			-.297,
			.373
		],
		8320: [
			.361,
			.028,
			.444
		],
		8353: [
			.79,
			.096,
			.639,
			{ ic: .084 }
		],
		8358: [
			.694,
			0,
			.708,
			{ ic: .052 }
		],
		8361: [
			.694,
			0,
			.944,
			{ ic: .135 }
		],
		8363: [
			.694,
			.064,
			.517,
			{ ic: .099 }
		],
		8369: [
			.694,
			0,
			.639,
			{ ic: .052 }
		],
		8370: [
			.75,
			.028,
			.778,
			{ ic: .067 }
		],
		8451: [
			.717,
			.021,
			.861,
			{ ic: .084 }
		],
		8470: [
			.695,
			0,
			.819,
			{ ic: .028 }
		],
		8471: [
			.694,
			0,
			.694,
			{ ic: .089 }
		],
		8478: [
			.694,
			0,
			.646,
			{ ic: .054 }
		],
		8480: [
			.694,
			-.252,
			.858,
			{ ic: .052 }
		],
		8482: [
			.698,
			-.282,
			.933,
			{ ic: .067 }
		],
		8494: [
			.712,
			.01,
			.669,
			{ ic: .062 }
		],
		8960: [
			.583,
			.083,
			.778,
			{ ic: .069 }
		],
		9250: [
			.694,
			.011,
			.517,
			{ ic: .018 }
		],
		9251: [
			.241,
			.118,
			.5,
			{ ic: .005 }
		],
		11800: [
			.528,
			.195,
			.472
		],
		64256: [
			.705,
			0,
			.583,
			{ ic: .19 }
		],
		64257: [
			.705,
			0,
			.536,
			{ ic: .07 }
		],
		64258: [
			.705,
			0,
			.536,
			{ ic: .066 }
		],
		64259: [
			.705,
			0,
			.814,
			{ ic: .07 }
		],
		64260: [
			.705,
			0,
			.814,
			{ ic: .066 }
		],
		65126: [
			.344,
			-.085,
			.333,
			{ ic: .018 }
		],
		184: [
			-.024,
			.192,
			.444
		],
		688: [
			.73,
			-.297,
			.373
		],
		689: [
			.727,
			-.297,
			.373,
			{ ic: .046 }
		],
		690: [
			.705,
			-.174,
			.223,
			{ ic: .039 }
		],
		691: [
			.57,
			-.297,
			.268,
			{ ic: .05 }
		],
		692: [
			.564,
			-.29,
			.268,
			{ ic: .008 }
		],
		693: [
			.564,
			-.166,
			.268,
			{ ic: .023 }
		],
		694: [
			.564,
			-.297,
			.333,
			{ ic: .045 }
		],
		695: [
			.564,
			-.297,
			.472,
			{ ic: .052 }
		],
		696: [
			.564,
			-.173,
			.339,
			{ ic: .052 }
		],
		697: [
			.694,
			-.495,
			.167,
			{ ic: .145 }
		],
		698: [
			.695,
			-.528,
			.5,
			{ ic: .068 }
		],
		699: [
			.695,
			-.486,
			.278,
			{ ic: .052 }
		],
		700: [
			.722,
			-.514,
			.278,
			{ ic: .056 }
		],
		701: [
			.695,
			-.486,
			.278,
			{ ic: .05 }
		],
		702: [
			.638,
			-.287,
			.397,
			{ ic: .046 }
		],
		703: [
			.638,
			-.287,
			.397,
			{ ic: .068 }
		],
		704: [
			.761,
			-.355,
			.444,
			{ ic: .077 }
		],
		705: [
			.761,
			-.355,
			.444,
			{ ic: .15 }
		],
		706: [
			.727,
			-.488,
			.333,
			{ ic: .118 }
		],
		707: [
			.727,
			-.488,
			.333,
			{ ic: .1 }
		],
		708: [
			.697,
			-.525,
			.5
		],
		709: [
			.697,
			-.525,
			.5
		],
		712: [
			.695,
			-.473,
			.222,
			{ ic: .068 }
		],
		716: [
			.027,
			.195,
			.222
		],
		718: [
			-.128,
			.258,
			.5
		],
		719: [
			-.128,
			.258,
			.5
		],
		720: [
			.445,
			0,
			.278,
			{ ic: .042 }
		],
		721: [
			.445,
			-.268,
			.278,
			{ ic: .041 }
		],
		722: [
			.425,
			-.142,
			.333
		],
		723: [
			.425,
			-.142,
			.333
		],
		724: [
			.283,
			-.086,
			.444
		],
		725: [
			.283,
			-.086,
			.444
		],
		726: [
			.283,
			0,
			.444
		],
		727: [
			.255,
			-.189,
			.444
		],
		731: [
			0,
			.212,
			.5
		],
		733: [
			.694,
			-.527,
			.5,
			{ ic: .068 }
		],
		734: [
			.483,
			-.22,
			.333,
			{ ic: .068 }
		],
		735: [
			.674,
			-.456,
			.5,
			{ ic: .035 }
		],
		736: [
			.564,
			-.167,
			.339,
			{ ic: .051 }
		],
		737: [
			.73,
			-.297,
			.206,
			{ ic: .044 }
		],
		738: [
			.574,
			-.291,
			.292,
			{ ic: .033 }
		],
		739: [
			.564,
			-.297,
			.339,
			{ ic: .053 }
		],
		740: [
			.72,
			-.297,
			.363,
			{ ic: .05 }
		],
		741: [
			.717,
			.022,
			.333,
			{ ic: .183 }
		],
		742: [
			.717,
			.022,
			.333,
			{ ic: .183 }
		],
		743: [
			.717,
			.022,
			.333,
			{ ic: .183 }
		],
		744: [
			.717,
			.022,
			.333,
			{ ic: .183 }
		],
		745: [
			.717,
			.023,
			.333,
			{ ic: .183 }
		],
		746: [
			.717,
			-.253,
			.333,
			{ ic: .01 }
		],
		747: [
			.717,
			.022,
			.343,
			{ ic: .074 }
		],
		748: [
			-.043,
			.215,
			.5
		],
		749: [
			.659,
			-.485,
			.5
		],
		750: [
			.723,
			-.514,
			.428
		],
		751: [
			.006,
			.212,
			.556,
			{ ic: .027 }
		],
		752: [
			.006,
			.212,
			.556,
			{ ic: .003 }
		],
		753: [
			-.043,
			.282,
			.333
		],
		754: [
			-.043,
			.282,
			.333
		],
		755: [
			-.04,
			.236,
			.296
		],
		756: [
			.325,
			-.158,
			.376
		],
		757: [
			.325,
			-.158,
			.546
		],
		758: [
			.325,
			-.158,
			.546
		],
		759: [
			-.041,
			.16,
			.433
		],
		760: [
			.544,
			-.292,
			.278
		],
		761: [
			.672,
			-.45,
			.289,
			{ ic: .132 }
		],
		762: [
			.672,
			-.45,
			.289,
			{ ic: .087 }
		],
		763: [
			.127,
			.095,
			.289
		],
		764: [
			.127,
			.095,
			.289,
			{ ic: .012 }
		],
		765: [
			.132,
			.096,
			.55
		],
		766: [
			.132,
			.096,
			.55
		],
		777: [
			.718,
			-.503,
			0,
			{ dx: .1 }
		],
		779: [
			.694,
			-.527,
			0,
			{ dx: .098 }
		],
		781: [
			.717,
			-.528,
			0,
			{ dx: .114 }
		],
		782: [
			.717,
			-.528,
			0,
			{ dx: .114 }
		],
		783: [
			.694,
			-.527,
			0,
			{ dx: .122 }
		],
		784: [
			.751,
			-.522,
			0,
			{ dx: .236 }
		],
		785: [
			.7,
			-.522,
			0,
			{ dx: .127 }
		],
		786: [
			.695,
			-.486,
			.278
		],
		787: [
			.694,
			-.511,
			0,
			{ dx: -.043 }
		],
		788: [
			.694,
			-.511,
			0,
			{ dx: .004 }
		],
		789: [
			.866,
			-.658,
			0,
			{ dx: -.161 }
		],
		790: [
			-.128,
			.258,
			0,
			{ dx: .339 }
		],
		791: [
			-.128,
			.258,
			0,
			{ dx: .244 }
		],
		792: [
			-.057,
			.309,
			.444
		],
		793: [
			-.057,
			.309,
			.444
		],
		794: [
			.806,
			-.584,
			.173,
			{ ic: .034 }
		],
		795: [
			.694,
			-.511,
			0,
			{ dx: .081 }
		],
		796: [
			-.041,
			.324,
			0,
			{ dx: .202 }
		],
		797: [
			-.057,
			.254,
			0,
			{ dx: .27 }
		],
		798: [
			-.057,
			.254,
			0,
			{ dx: .24 }
		],
		799: [
			-.057,
			.34,
			0,
			{ dx: .264 }
		],
		800: [
			-.051,
			.117,
			0,
			{ dx: .24 }
		],
		801: [
			.011,
			.217,
			0,
			{ dx: .201 }
		],
		802: [
			.011,
			.217,
			0,
			{ dx: .066 }
		],
		803: [
			-.111,
			.2,
			0,
			{ dx: .274 }
		],
		804: [
			-.066,
			.156,
			0,
			{ dx: .274 }
		],
		805: [
			-.064,
			.225,
			0,
			{ dx: .393 }
		],
		806: [
			-.079,
			.266,
			0,
			{ dx: .278 }
		],
		807: [
			-.023,
			.192,
			0,
			{ dx: .282 }
		],
		808: [
			.051,
			.214,
			0,
			{ dx: .216 }
		],
		809: [
			-.057,
			.279,
			0,
			{ dx: .146 }
		],
		810: [
			-.111,
			.295,
			0,
			{ dx: .294 }
		],
		811: [
			-.094,
			.303,
			0,
			{ dx: .288 }
		],
		812: [
			-.064,
			.158,
			0,
			{ dx: .263 }
		],
		813: [
			-.065,
			.206,
			0,
			{ dx: .296 }
		],
		814: [
			-.066,
			.244,
			0,
			{ dx: .255 }
		],
		815: [
			-.066,
			.244,
			0,
			{ dx: .29 }
		],
		816: [
			-.095,
			.214,
			0,
			{ dx: .272 }
		],
		817: [
			-.123,
			.187,
			0,
			{ dx: .273 }
		],
		818: [
			-.123,
			.187,
			0,
			{ dx: .273 }
		],
		819: [
			-.043,
			.227,
			0,
			{ dx: .239 }
		],
		820: [
			.319,
			-.209,
			0
		],
		821: [
			.272,
			-.216,
			0
		],
		822: [
			.272,
			-.216,
			0
		],
		823: [
			.353,
			-.098,
			0
		],
		825: [
			-.041,
			.324,
			0,
			{ dx: .211 }
		],
		826: [
			-.111,
			.295,
			0,
			{ dx: .294 }
		],
		827: [
			-.111,
			.325,
			0,
			{ dx: .297 }
		],
		828: [
			-.101,
			.266,
			0,
			{ dx: .299 }
		],
		829: [
			.674,
			-.456,
			0,
			{ dx: .131 }
		],
		830: [
			.827,
			-.494,
			0,
			{ dx: .239 }
		],
		831: [
			.682,
			-.542,
			.778
		],
		832: [
			.694,
			-.527,
			0,
			{ dx: .276 }
		],
		833: [
			.694,
			-.527,
			0,
			{ dx: .204 }
		],
		834: [
			.66,
			-.563,
			0,
			{ dx: .236 }
		],
		835: [
			.694,
			-.511,
			.222
		],
		836: [
			.694,
			-.489,
			.264
		],
		837: [
			-.067,
			.238,
			.111,
			{ ic: .001 }
		],
		838: [
			.676,
			-.492,
			0,
			{ dx: .127 }
		],
		839: [
			-.069,
			.328,
			0,
			{ dx: .232 }
		],
		840: [
			-.143,
			.332,
			0,
			{ dx: .297 }
		],
		841: [
			-.067,
			.289,
			0,
			{ dx: .189 }
		],
		842: [
			.74,
			-.466,
			0,
			{ dx: .239 }
		],
		843: [
			.741,
			-.489,
			0,
			{ dx: .239 }
		],
		844: [
			.685,
			-.485,
			.449
		],
		845: [
			-.025,
			.275,
			0,
			{ dx: .31 }
		],
		846: [
			-.041,
			.34,
			0,
			{ dx: .279 }
		],
		848: [
			.733,
			-.483,
			.273
		],
		849: [
			.7,
			-.504,
			.296
		],
		850: [
			.751,
			-.522,
			0,
			{ dx: .242 }
		],
		851: [
			-.042,
			.289,
			0,
			{ dx: .223 }
		],
		852: [
			-.025,
			.275,
			0,
			{ dx: .198 }
		],
		853: [
			-.025,
			.275,
			0,
			{ dx: .225 }
		],
		854: [
			-.025,
			.275,
			0,
			{ dx: .112 }
		],
		855: [
			.7,
			-.504,
			.296
		],
		856: [
			.655,
			-.566,
			0,
			{ dx: .051 }
		],
		857: [
			-.043,
			.269,
			.25
		],
		858: [
			-.052,
			.24,
			0,
			{ dx: .265 }
		],
		859: [
			.757,
			-.451,
			.5
		],
		860: [
			-.098,
			.354,
			0,
			{ dx: .367 }
		],
		861: [
			.733,
			-.477,
			0,
			{ dx: -.133 }
		],
		862: [
			.587,
			-.518,
			0,
			{ dx: -.001 }
		],
		863: [
			-.118,
			.187,
			0,
			{ dx: -.001 }
		],
		864: [
			.724,
			-.567,
			0,
			{ dx: -.136 }
		],
		865: [
			.719,
			-.463,
			0,
			{ dx: -.137 }
		],
		866: [
			-.025,
			.275,
			0,
			{ dx: .033 }
		],
		867: [
			.711,
			-.46,
			.25
		],
		868: [
			.71,
			-.459,
			.252
		],
		869: [
			.802,
			-.46,
			.135
		],
		870: [
			.71,
			-.459,
			.275
		],
		871: [
			.701,
			-.46,
			.275
		],
		872: [
			.711,
			-.459,
			.27
		],
		873: [
			.827,
			-.459,
			.267,
			{ ic: .008 }
		],
		874: [
			.822,
			-.462,
			.253
		],
		875: [
			.701,
			-.459,
			.411
		],
		876: [
			.702,
			-.46,
			.203
		],
		877: [
			.766,
			-.46,
			.214
		],
		878: [
			.694,
			-.457,
			.289
		],
		879: [
			.698,
			-.46,
			.307
		],
		7620: [
			.695,
			-.488,
			0,
			{ dx: .104 }
		],
		7621: [
			.695,
			-.488,
			0,
			{ dx: .137 }
		],
		7624: [
			.695,
			-.528,
			0,
			{ dx: .12 }
		],
		7625: [
			.695,
			-.528,
			0,
			{ dx: .121 }
		],
		9474: [
			.75,
			.25,
			.278,
			{ ic: .06 }
		],
		9553: [
			.75,
			.25,
			.5,
			{ ic: .044 }
		],
		9773: [
			.593,
			.001,
			.7
		],
		9792: [
			.467,
			.217,
			.5,
			{ ic: .012 }
		],
		9834: [
			.723,
			.03,
			.611
		],
		9901: [
			.473,
			-.029,
			.5,
			{ ic: .147 }
		],
		9902: [
			.615,
			.113,
			.5,
			{ ic: .259 }
		],
		9906: [
			.467,
			.217,
			.5,
			{ ic: .011 }
		],
		10013: [
			.625,
			.028,
			.5,
			{ ic: .037 }
		],
		59395: [
			.705,
			0,
			.792,
			{ ic: .058 }
		],
		59908: [
			.857,
			-.522,
			.5,
			{ ic: .087 }
		],
		59909: [
			-.066,
			.244,
			.5
		],
		59910: [
			-.066,
			.244,
			.5
		],
		59913: [
			.857,
			-.522,
			.5,
			{ ic: .069 }
		],
		59915: [
			.93,
			-.522,
			.5,
			{ ic: .069 }
		],
		59917: [
			.7,
			-.522,
			.5,
			{ ic: .034 }
		],
		59920: [
			.874,
			-.522,
			.5,
			{ ic: .104 }
		],
		59927: [
			.816,
			-.525,
			.5,
			{ ic: .077 }
		],
		59930: [
			.816,
			-.525,
			.5,
			{ ic: .048 }
		],
		59932: [
			.889,
			-.525,
			.5,
			{ ic: .118 }
		],
		59934: [
			.833,
			-.525,
			.5,
			{ ic: .095 }
		],
		59935: [
			-.079,
			.266,
			.5
		],
		59942: [
			.694,
			-.527,
			.5,
			{ ic: .005 }
		],
		59946: [
			.829,
			-.571,
			.5,
			{ ic: .128 }
		],
		59948: [
			.831,
			-.571,
			.5,
			{ ic: .09 }
		],
		59951: [
			.829,
			-.571,
			.5,
			{ ic: .002 }
		],
		59957: [
			.718,
			-.503,
			.5
		],
		59962: [
			-.123,
			.187,
			.5
		],
		59966: [
			-.123,
			.187,
			.5
		],
		59970: [
			.842,
			-.517,
			.738
		],
		59973: [
			-.095,
			.214,
			.5
		],
		60163: [
			.868,
			.212,
			.667,
			{ ic: .052 }
		],
		60164: [
			.694,
			.212,
			.481,
			{ ic: .054 }
		],
		60168: [
			.694,
			0,
			.694,
			{ ic: .089 }
		],
		60175: [
			.694,
			0,
			.694,
			{ ic: .089 }
		],
		60176: [
			0,
			0,
			0
		],
		60177: [
			0,
			0,
			0
		],
		60178: [
			0,
			0,
			0
		],
		60182: [
			.626,
			.027,
			.5,
			{ ic: .037 }
		],
		60185: [
			-.111,
			.2,
			.278
		],
		60190: [
			.868,
			.212,
			.597,
			{ ic: .091 }
		],
		60191: [
			.694,
			.212,
			.444,
			{ ic: .073 }
		],
		60200: [
			.716,
			.022,
			1.111,
			{ ic: .053 }
		],
		60201: [
			.5,
			.226,
			.472
		],
		60203: [
			.79,
			.096,
			.667,
			{ ic: .067 }
		],
		60209: [
			.345,
			-.086,
			.167,
			{ ic: .184 }
		],
		60213: [
			.868,
			.212,
			.278,
			{ ic: .297 }
		],
		60214: [
			.694,
			.212,
			.239,
			{ ic: .207 }
		],
		60218: [
			.868,
			.022,
			.472,
			{ ic: .312 }
		],
		60219: [
			.694,
			.205,
			.267,
			{ ic: .207 }
		],
		60224: [
			.77,
			.047,
			1,
			{ ic: .169 }
		],
		60232: [
			.868,
			.212,
			.736,
			{ ic: .027 }
		],
		60233: [
			.694,
			.212,
			.5,
			{ ic: .045 }
		],
		60237: [
			.347,
			.056,
			.392
		],
		60257: [
			.399,
			-.265,
			.239,
			{ ic: .079 }
		],
		60259: [
			.639,
			-.477,
			.294,
			{ ic: .41 }
		],
		60261: [
			.692,
			-.568,
			.239,
			{ ic: .407 }
		],
		60270: [
			.694,
			.244,
			.688,
			{ ic: .054 }
		],
		60271: [
			.444,
			.244,
			.517,
			{ ic: .013 }
		],
		60424: [
			.855,
			0,
			.708,
			{ ic: .054 }
		],
		60425: [
			.855,
			0,
			.517,
			{ ic: .091 }
		],
		60426: [
			.855,
			0,
			.542
		],
		60427: [
			.855,
			0,
			.239,
			{ ic: .231 }
		],
		60428: [
			.855,
			0,
			.681,
			{ ic: .11 }
		],
		60429: [
			.732,
			.011,
			.361,
			{ ic: .103 }
		],
		60430: [
			.816,
			0,
			.681,
			{ ic: .11 }
		],
		60432: [
			.881,
			.186,
			.736,
			{ ic: .026 }
		],
		60433: [
			.631,
			.186,
			.5,
			{ ic: .022 }
		],
		61699: [
			.716,
			.022,
			1.111,
			{ ic: .052 }
		],
		61700: [
			.305,
			-.244,
			.667,
			{ ic: .064 }
		],
		61705: [
			.127,
			0,
			.611
		],
		61719: [
			.353,
			-.098,
			.239,
			{ ic: .043 }
		],
		61720: [
			.759,
			.055,
			.528,
			{ ic: .017 }
		],
		61721: [
			.753,
			.041,
			.444,
			{ ic: .019 }
		],
		61722: [
			.694,
			.217,
			.694,
			{ ic: .055 }
		],
		61723: [
			.445,
			.205,
			.537,
			{ ic: .014 }
		],
		61724: [
			.694,
			.195,
			.728,
			{ ic: .037 }
		],
		61725: [
			.694,
			.195,
			.891,
			{ ic: .031 }
		],
		61726: [
			.694,
			.195,
			.639,
			{ ic: .052 }
		],
		61729: [
			.445,
			.162,
			.539,
			{ ic: .001 }
		],
		61730: [
			.445,
			.162,
			.68,
			{ ic: .003 }
		],
		61731: [
			.455,
			.311,
			.517,
			{ ic: .018 }
		],
		61734: [
			.694,
			.195,
			.542,
			{ ic: .105 }
		],
		61735: [
			.716,
			.022,
			.639,
			{ ic: .084 }
		],
		61736: [
			.445,
			.162,
			.39,
			{ ic: .084 }
		],
		61737: [
			.461,
			.011,
			.444,
			{ ic: .057 }
		],
		61738: [
			.694,
			.217,
			.875,
			{ ic: .048 }
		],
		61739: [
			.694,
			.217,
			.639,
			{ ic: .052 }
		],
		61740: [
			.445,
			.205,
			.669,
			{ ic: .014 }
		],
		61741: [
			.455,
			.322,
			.517,
			{ ic: .018 }
		],
		61743: [
			.658,
			.205,
			.555,
			{ ic: .099 }
		],
		61747: [
			.694,
			0,
			.667
		],
		61748: [
			.822,
			0,
			.639,
			{ ic: .066 }
		],
		61749: [
			.455,
			.011,
			.633
		],
		61750: [
			.625,
			.011,
			.417,
			{ ic: .016 }
		],
		61751: [
			.005,
			.208,
			.139
		],
		61752: [
			.004,
			.206,
			.194
		],
		61757: [
			.722,
			-.526,
			.667,
			{ ic: .158 }
		],
		61761: [
			.695,
			-.528,
			.5,
			{ ic: .031 }
		],
		61762: [
			.695,
			-.528,
			.5
		],
		61763: [
			.283,
			-.031,
			.444
		],
		61764: [
			.283,
			-.031,
			.444
		],
		61765: [
			.695,
			-.4,
			.333,
			{ ic: .124 }
		],
		61766: [
			.678,
			-.41,
			.222,
			{ ic: .199 }
		],
		61771: [
			.039,
			.039,
			.333,
			{ ic: .038 }
		],
		61772: [
			.212,
			.039,
			.333,
			{ ic: .039 }
		],
		61773: [
			.386,
			.039,
			.333,
			{ ic: .038 }
		],
		61774: [
			.56,
			.039,
			.333,
			{ ic: .038 }
		],
		61775: [
			.733,
			.039,
			.333,
			{ ic: .038 }
		],
		61776: [
			.212,
			.039,
			.333,
			{ ic: .075 }
		],
		61777: [
			.386,
			.039,
			.333,
			{ ic: .112 }
		],
		61778: [
			.56,
			.039,
			.333,
			{ ic: .149 }
		],
		61779: [
			.733,
			.04,
			.333,
			{ ic: .186 }
		],
		61780: [
			.039,
			.039,
			.222,
			{ ic: .039 }
		],
		61781: [
			.212,
			.039,
			.222,
			{ ic: .039 }
		],
		61782: [
			.386,
			.039,
			.222,
			{ ic: .038 }
		],
		61783: [
			.56,
			.039,
			.222,
			{ ic: .038 }
		],
		61784: [
			.733,
			.039,
			.222,
			{ ic: .038 }
		],
		61785: [
			.212,
			.039,
			.222,
			{ ic: .075 }
		],
		61786: [
			.386,
			.039,
			.222,
			{ ic: .112 }
		],
		61787: [
			.56,
			.039,
			.222,
			{ ic: .149 }
		],
		61788: [
			.733,
			.039,
			.222,
			{ ic: .186 }
		],
		61791: [
			.695,
			-.488,
			.5
		],
		61792: [
			.695,
			-.488,
			.5
		],
		61793: [
			.695,
			-.528,
			.5
		],
		61794: [
			.695,
			-.528,
			.5
		],
		61795: [
			.695,
			-.528,
			.5,
			{ ic: .032 }
		],
		61796: [
			.695,
			-.528,
			.5,
			{ ic: .068 }
		],
		61797: [
			.455,
			.195,
			.314
		],
		61800: [
			.461,
			.016,
			.722,
			{ ic: .03 }
		],
		61804: [
			.445,
			.205,
			.267,
			{ ic: .014 }
		],
		61805: [
			.027,
			.205,
			.333
		],
		61806: [
			.1,
			.217,
			.222,
			{ ic: .034 }
		],
		61807: [
			.1,
			.217,
			.222
		],
		61808: [
			.1,
			.217,
			.278
		],
		61809: [
			.684,
			-.445,
			.339,
			{ ic: .091 }
		],
		61810: [
			.732,
			-.482,
			.444,
			{ ic: .1 }
		],
		61813: [
			.455,
			.011,
			.517,
			{ ic: .013 }
		],
		61817: [
			.711,
			.22,
			.5,
			{ ic: .056 }
		],
		61818: [
			.461,
			.22,
			.444,
			{ ic: .057 }
		],
		61819: [
			.695,
			.011,
			.697,
			{ ic: .067 }
		],
		61822: [
			.455,
			.217,
			.556,
			{ ic: .042 }
		],
		61823: [
			.455,
			.217,
			.556,
			{ ic: .042 }
		],
		61824: [
			.717,
			.217,
			.536,
			{ ic: .039 }
		],
		61826: [
			.679,
			.205,
			.331,
			{ ic: .026 }
		],
		61828: [
			.695,
			0,
			.794
		],
		61829: [
			.455,
			0,
			.628
		],
		61832: [
			.455,
			.002,
			.611,
			{ ic: .03 }
		],
		61833: [
			.455,
			.217,
			.544,
			{ ic: .02 }
		],
		61834: [
			.571,
			.011,
			.528,
			{ ic: .05 }
		],
		61835: [
			.455,
			.252,
			.361
		],
		61836: [
			.445,
			.233,
			.5,
			{ ic: .044 }
		],
		61837: [
			.467,
			.233,
			.5,
			{ ic: .035 }
		],
		61838: [
			.695,
			.067,
			.5
		],
		61839: [
			.695,
			.011,
			.5
		],
		61842: [
			.695,
			0,
			.342,
			{ ic: .083 }
		],
		61850: [
			.445,
			0,
			.463,
			{ ic: .07 }
		],
		61854: [
			.445,
			0,
			.483,
			{ ic: .038 }
		],
		61855: [
			.445,
			0,
			.372,
			{ ic: .038 }
		],
		61857: [
			.46,
			0,
			.484,
			{ ic: .009 }
		],
		61859: [
			.717,
			-.528,
			.5
		],
		61860: [
			.717,
			-.528,
			.5,
			{ ic: .02 }
		],
		61863: [
			.011,
			.217,
			.222
		],
		61864: [
			.011,
			.217,
			.222,
			{ ic: .034 }
		],
		61865: [
			-.111,
			.295,
			.5
		],
		61866: [
			-.094,
			.303,
			.5
		],
		61867: [
			.272,
			-.216,
			.278
		],
		61868: [
			.353,
			-.098,
			.239
		],
		61869: [
			-.111,
			.295,
			.5
		],
		61870: [
			-.111,
			.325,
			.5
		],
		61871: [
			-.101,
			.266,
			.5
		],
		61872: [
			-.025,
			.275,
			.556
		],
		61873: [
			.661,
			-.467,
			.555
		],
		61874: [
			.738,
			-.508,
			.5
		],
		61875: [
			.738,
			-.508,
			.5
		],
		61876: [
			.802,
			.302,
			1.111
		],
		61877: [
			.854,
			.354,
			1.111
		],
		62082: [
			.07,
			0,
			.278
		],
		62083: [
			.728,
			-.511,
			.5
		],
		62110: [
			.733,
			-.508,
			.5
		],
		62113: [
			.694,
			.022,
			.639,
			{ ic: .051 }
		],
		62116: [
			.694,
			0,
			.694,
			{ ic: .054 }
		],
		62119: [
			.694,
			0,
			.694,
			{ ic: .053 }
		],
		62120: [
			.694,
			.195,
			1.091,
			{ ic: .044 }
		],
		62121: [
			.445,
			.011,
			.48,
			{ ic: .013 }
		],
		62124: [
			.445,
			0,
			.537,
			{ ic: .013 }
		],
		62126: [
			.445,
			0,
			.537,
			{ ic: .013 }
		],
		62127: [
			.445,
			.162,
			.76,
			{ ic: .012 }
		],
		62560: [
			.85,
			0,
			.667,
			{ ic: .002 }
		],
		62561: [
			.857,
			0,
			.597,
			{ ic: .093 }
		],
		62562: [
			.857,
			0,
			.694,
			{ ic: .054 }
		],
		62563: [
			.85,
			.022,
			.736,
			{ ic: .027 }
		],
		62564: [
			.857,
			0,
			.667,
			{ ic: .135 }
		],
		62565: [
			.857,
			0,
			.889,
			{ ic: .047 }
		],
		62566: [
			.857,
			.022,
			.639,
			{ ic: .016 }
		],
		62567: [
			.857,
			.022,
			1.041,
			{ ic: .027 }
		],
		62568: [
			.857,
			0,
			.646,
			{ ic: .058 }
		],
		62570: [
			.64,
			.011,
			.48,
			{ ic: .011 }
		],
		62571: [
			.64,
			.011,
			.444,
			{ ic: .028 }
		],
		62572: [
			.641,
			0,
			.537,
			{ ic: .013 }
		],
		62573: [
			.64,
			.011,
			.5,
			{ ic: .046 }
		],
		62574: [
			.641,
			.205,
			.461,
			{ ic: .083 }
		],
		62575: [
			.641,
			0,
			.683,
			{ ic: .013 }
		],
		62576: [
			.641,
			.011,
			.444,
			{ ic: .031 }
		],
		62577: [
			.641,
			.011,
			.73,
			{ ic: .022 }
		],
		62578: [
			.641,
			0,
			.515,
			{ ic: .042 }
		],
		63166: [
			.444,
			.205,
			.267,
			{ ic: .012 }
		],
		63187: [
			.851,
			-.76,
			.5,
			{ ic: .185 }
		],
		63188: [
			.639,
			-.5,
			.5,
			{ ic: .056 }
		],
		63189: [
			.65,
			-.51,
			.5,
			{ ic: .029 }
		],
		63190: [
			.64,
			-.51,
			.5,
			{ ic: .004 }
		],
		63198: [
			.305,
			-.244,
			.75,
			{ ic: .065 }
		],
		8592: [
			.511,
			.009,
			1,
			{ ic: .001 }
		],
		8593: [
			.712,
			.195,
			.5,
			{ ic: .072 }
		],
		8594: [
			.511,
			.009,
			1
		],
		8595: [
			.695,
			.211,
			.5
		],
		8730: [
			.763,
			.104,
			.472,
			{ ic: .212 }
		],
		8738: [
			.583,
			.083,
			.778,
			{ ic: .048 }
		],
		9001: [
			.751,
			.249,
			.389,
			{ ic: .102 }
		],
		9002: [
			.751,
			.249,
			.389
		],
		9702: [
			.407,
			-.121,
			.778
		],
		10214: [
			.751,
			.249,
			.403,
			{ ic: .138 }
		],
		10215: [
			.751,
			.249,
			.403,
			{ ic: .042 }
		]
	} },
	SSBIX: { "sans-serif-bold-italic": {
		161: [
			.5,
			.194,
			.367
		],
		162: [
			.548,
			.089,
			.459,
			{ ic: .053 }
		],
		164: [
			.541,
			.041,
			.856
		],
		166: [
			.75,
			.25,
			.319,
			{ ic: .03 }
		],
		169: [
			.694,
			0,
			.694,
			{ ic: .115 }
		],
		170: [
			.715,
			-.276,
			.416,
			{ ic: .117 }
		],
		171: [
			.5,
			0,
			.55,
			{ ic: .045 }
		],
		173: [
			.265,
			-.193,
			.367
		],
		174: [
			.694,
			0,
			.694,
			{ ic: .115 }
		],
		186: [
			.684,
			-.278,
			.461,
			{ ic: .061 }
		],
		187: [
			.5,
			0,
			.55
		],
		188: [
			.739,
			.037,
			.88,
			{ ic: .033 }
		],
		189: [
			.739,
			.037,
			.978,
			{ ic: .023 }
		],
		190: [
			.739,
			.037,
			.88,
			{ ic: .033 }
		],
		191: [
			.528,
			.178,
			.519
		],
		3647: [
			.794,
			.1,
			.733,
			{ ic: .045 }
		],
		8218: [
			.129,
			.113,
			.306
		],
		8219: [
			.695,
			-.453,
			.306,
			{ ic: .066 }
		],
		8222: [
			.129,
			.113,
			.529
		],
		8223: [
			.722,
			-.48,
			.61
		],
		8226: [
			.418,
			-.114,
			.856
		],
		8233: [
			.722,
			.194,
			.519,
			{ ic: .153 }
		],
		8240: [
			.773,
			.079,
			1.4
		],
		8241: [
			.773,
			.079,
			1.845
		],
		8249: [
			.5,
			0,
			.319,
			{ ic: .048 }
		],
		8250: [
			.5,
			0,
			.319
		],
		8251: [
			.541,
			.04,
			.856
		],
		8253: [
			.743,
			0,
			.487,
			{ ic: .108 }
		],
		8255: [
			-.063,
			.194,
			.649
		],
		8256: [
			.696,
			-.565,
			.649,
			{ ic: .083 }
		],
		8261: [
			.751,
			.252,
			.397,
			{ ic: .104 }
		],
		8262: [
			.751,
			.252,
			.397,
			{ ic: .096 }
		],
		8274: [
			.768,
			.016,
			.55,
			{ ic: .113 }
		],
		8276: [
			-.063,
			.194,
			.649
		],
		8319: [
			.587,
			-.305,
			.336,
			{ ic: .086 }
		],
		8320: [
			.361,
			.03,
			.489
		],
		8353: [
			.885,
			.193,
			.703,
			{ ic: .073 }
		],
		8358: [
			.694,
			0,
			.794,
			{ ic: .082 }
		],
		8361: [
			.694,
			0,
			1.039,
			{ ic: .131 }
		],
		8363: [
			.654,
			.168,
			.561,
			{ ic: .092 }
		],
		8369: [
			.694,
			0,
			.703,
			{ ic: .052 }
		],
		8370: [
			.887,
			.191,
			.733,
			{ ic: .055 }
		],
		8451: [
			.706,
			.011,
			1.053,
			{ ic: .073 }
		],
		8470: [
			.694,
			0,
			.959,
			{ ic: .062 }
		],
		8471: [
			.694,
			0,
			.694,
			{ ic: .115 }
		],
		8478: [
			.694,
			0,
			.703,
			{ ic: .076 }
		],
		8480: [
			.711,
			-.27,
			.869,
			{ ic: .115 }
		],
		8482: [
			.698,
			-.28,
			.952,
			{ ic: .115 }
		],
		8494: [
			.712,
			.01,
			.758,
			{ ic: .087 }
		],
		8960: [
			.636,
			.135,
			.856,
			{ ic: .079 }
		],
		9250: [
			.653,
			.01,
			.627,
			{ ic: .04 }
		],
		9251: [
			.276,
			.122,
			.55,
			{ ic: .013 }
		],
		11800: [
			.529,
			.214,
			.487
		],
		64256: [
			.706,
			0,
			.642,
			{ ic: .19 }
		],
		64257: [
			.706,
			0,
			.586,
			{ ic: .084 }
		],
		64258: [
			.706,
			0,
			.586,
			{ ic: .085 }
		],
		64259: [
			.706,
			0,
			.892,
			{ ic: .084 }
		],
		64260: [
			.706,
			0,
			.892,
			{ ic: .085 }
		],
		65126: [
			.354,
			-.053,
			.367,
			{ ic: .009 }
		],
		184: [
			-.023,
			.194,
			.489
		],
		688: [
			.73,
			-.306,
			.336,
			{ ic: .09 }
		],
		689: [
			.772,
			-.306,
			.336,
			{ ic: .153 }
		],
		690: [
			.717,
			-.183,
			.173,
			{ ic: .111 }
		],
		691: [
			.601,
			-.305,
			.223,
			{ ic: .12 }
		],
		692: [
			.601,
			-.305,
			.223,
			{ ic: .07 }
		],
		693: [
			.58,
			-.159,
			.223,
			{ ic: .112 }
		],
		694: [
			.597,
			-.299,
			.33,
			{ ic: .095 }
		],
		695: [
			.593,
			-.305,
			.446,
			{ ic: .122 }
		],
		696: [
			.581,
			-.184,
			.3,
			{ ic: .118 }
		],
		697: [
			.695,
			-.507,
			.183,
			{ ic: .158 }
		],
		698: [
			.695,
			-.507,
			.423,
			{ ic: .118 }
		],
		699: [
			.722,
			-.48,
			.305,
			{ ic: .057 }
		],
		700: [
			.722,
			-.48,
			.305,
			{ ic: .059 }
		],
		701: [
			.695,
			-.453,
			.306,
			{ ic: .066 }
		],
		702: [
			.63,
			-.268,
			.436,
			{ ic: .055 }
		],
		703: [
			.63,
			-.268,
			.436,
			{ ic: .058 }
		],
		704: [
			.761,
			-.496,
			.489,
			{ ic: .038 }
		],
		705: [
			.761,
			-.496,
			.489,
			{ ic: .033 }
		],
		706: [
			.737,
			-.487,
			.367,
			{ ic: .122 }
		],
		707: [
			.737,
			-.487,
			.367,
			{ ic: .102 }
		],
		708: [
			.694,
			-.546,
			.55,
			{ ic: .006 }
		],
		709: [
			.661,
			-.513,
			.55,
			{ ic: .03 }
		],
		712: [
			.694,
			-.451,
			.244,
			{ ic: .06 }
		],
		716: [
			.049,
			.194,
			.244
		],
		718: [
			-.132,
			.287,
			.55
		],
		719: [
			-.136,
			.288,
			.55
		],
		720: [
			.458,
			.003,
			.306,
			{ ic: .028 }
		],
		721: [
			.458,
			-.281,
			.306,
			{ ic: .03 }
		],
		722: [
			.454,
			-.15,
			.367
		],
		723: [
			.454,
			-.15,
			.367,
			{ ic: .01 }
		],
		724: [
			.317,
			-.065,
			.489
		],
		725: [
			.317,
			-.065,
			.489
		],
		726: [
			.313,
			-.004,
			.489
		],
		727: [
			.275,
			-.183,
			.489
		],
		731: [
			.018,
			.213,
			.55
		],
		733: [
			.694,
			-.546,
			.55,
			{ ic: .054 }
		],
		734: [
			.463,
			-.214,
			.367,
			{ ic: .1 }
		],
		735: [
			.672,
			-.462,
			.55,
			{ ic: .034 }
		],
		736: [
			.58,
			-.174,
			.3,
			{ ic: .106 }
		],
		737: [
			.738,
			-.305,
			.153,
			{ ic: .12 }
		],
		738: [
			.59,
			-.298,
			.253,
			{ ic: .095 }
		],
		739: [
			.58,
			-.305,
			.3,
			{ ic: .095 }
		],
		740: [
			.729,
			-.305,
			.33,
			{ ic: .108 }
		],
		741: [
			.716,
			.022,
			.367,
			{ ic: .219 }
		],
		742: [
			.717,
			.022,
			.367,
			{ ic: .219 }
		],
		743: [
			.717,
			.022,
			.367,
			{ ic: .219 }
		],
		744: [
			.717,
			.022,
			.367,
			{ ic: .219 }
		],
		745: [
			.716,
			.022,
			.367,
			{ ic: .219 }
		],
		746: [
			.716,
			-.228,
			.367,
			{ ic: .155 }
		],
		747: [
			.717,
			.022,
			.367,
			{ ic: .173 }
		],
		748: [
			-.042,
			.19,
			.55
		],
		749: [
			.767,
			-.532,
			.55,
			{ ic: .224 }
		],
		750: [
			.722,
			-.48,
			.505,
			{ ic: .059 }
		],
		751: [
			0,
			.228,
			.556
		],
		752: [
			0,
			.228,
			.556
		],
		753: [
			-.041,
			.291,
			.367
		],
		754: [
			-.041,
			.291,
			.367
		],
		755: [
			-.041,
			.224,
			.223
		],
		756: [
			.314,
			-.167,
			.436
		],
		757: [
			.314,
			-.167,
			.554
		],
		758: [
			.314,
			-.167,
			.554,
			{ ic: .016 }
		],
		759: [
			-.042,
			.169,
			.55
		],
		760: [
			.544,
			-.203,
			.306,
			{ ic: .027 }
		],
		761: [
			.672,
			-.431,
			.318,
			{ ic: .126 }
		],
		762: [
			.672,
			-.431,
			.318,
			{ ic: .126 }
		],
		763: [
			.129,
			.112,
			.318
		],
		764: [
			.129,
			.112,
			.318,
			{ ic: .01 }
		],
		765: [
			.129,
			.112,
			.558,
			{ ic: .01 }
		],
		766: [
			.129,
			.112,
			.558
		],
		777: [
			.72,
			-.513,
			0,
			{ dx: .117 }
		],
		779: [
			.695,
			-.507,
			0,
			{ dx: .101 }
		],
		781: [
			.717,
			-.529,
			0,
			{ dx: .124 }
		],
		782: [
			.717,
			-.529,
			0,
			{ dx: .128 }
		],
		783: [
			.695,
			-.507,
			0,
			{ dx: .164 }
		],
		784: [
			.817,
			-.533,
			.256
		],
		785: [
			.685,
			-.513,
			.256
		],
		786: [
			.722,
			-.48,
			.305,
			{ ic: .057 }
		],
		787: [
			.692,
			-.45,
			0,
			{ dx: -.012 }
		],
		788: [
			.692,
			-.45,
			0,
			{ dx: -.022 }
		],
		789: [
			.866,
			-.624,
			0,
			{ dx: -.153 }
		],
		790: [
			-.136,
			.283,
			0,
			{ dx: .367 }
		],
		791: [
			-.136,
			.284,
			0,
			{ dx: .266 }
		],
		792: [
			-.066,
			.38,
			.489
		],
		793: [
			-.066,
			.38,
			.489
		],
		794: [
			.806,
			-.565,
			.18,
			{ ic: .205 }
		],
		795: [
			.692,
			-.45,
			0,
			{ dx: -.012 }
		],
		796: [
			-.042,
			.346,
			0,
			{ dx: .232 }
		],
		797: [
			-.095,
			.317,
			0,
			{ dx: .304 }
		],
		798: [
			-.063,
			.285,
			0,
			{ dx: .266 }
		],
		799: [
			-.066,
			.375,
			0,
			{ dx: .292 }
		],
		800: [
			-.059,
			.144,
			0,
			{ dx: .27 }
		],
		801: [
			.024,
			.217,
			0,
			{ dx: .22 }
		],
		802: [
			.024,
			.217,
			0,
			{ dx: .243 }
		],
		803: [
			-.09,
			.195,
			0,
			{ dx: .292 }
		],
		804: [
			-.09,
			.195,
			0,
			{ dx: .306 }
		],
		805: [
			-.058,
			.241,
			.223
		],
		806: [
			-.066,
			.308,
			0,
			{ dx: .303 }
		],
		807: [
			-.023,
			.194,
			0,
			{ dx: .316 }
		],
		808: [
			.008,
			.223,
			0,
			{ dx: .23 }
		],
		809: [
			-.063,
			.306,
			0,
			{ dx: .162 }
		],
		810: [
			-.111,
			.297,
			0,
			{ dx: .32 }
		],
		811: [
			-.112,
			.308,
			0,
			{ dx: .318 }
		],
		812: [
			-.062,
			.21,
			0,
			{ dx: .269 }
		],
		813: [
			-.062,
			.21,
			0,
			{ dx: .301 }
		],
		814: [
			-.041,
			.213,
			0,
			{ dx: .281 }
		],
		815: [
			-.041,
			.213,
			0,
			{ dx: .296 }
		],
		816: [
			-.08,
			.207,
			0,
			{ dx: .292 }
		],
		817: [
			-.099,
			.184,
			0,
			{ dx: .291 }
		],
		818: [
			-.099,
			.184,
			0,
			{ dx: .291 }
		],
		819: [
			-.042,
			.267,
			0,
			{ dx: .294 }
		],
		820: [
			.333,
			-.206,
			0
		],
		821: [
			.284,
			-.219,
			0
		],
		822: [
			.284,
			-.219,
			0
		],
		823: [
			.448,
			-.12,
			0
		],
		825: [
			-.042,
			.346,
			0,
			{ dx: .219 }
		],
		826: [
			-.115,
			.301,
			0,
			{ dx: .32 }
		],
		827: [
			-.111,
			.337,
			0,
			{ dx: .324 }
		],
		828: [
			-.1,
			.233,
			0,
			{ dx: .317 }
		],
		829: [
			.672,
			-.462,
			0,
			{ dx: .155 }
		],
		830: [
			.864,
			-.498,
			.209,
			{ ic: .153 }
		],
		831: [
			.772,
			-.537,
			.855,
			{ ic: .071 }
		],
		832: [
			.684,
			-.537,
			.55
		],
		833: [
			.685,
			-.537,
			.55,
			{ ic: .044 }
		],
		834: [
			.65,
			-.52,
			.633
		],
		835: [
			.694,
			-.511,
			.222,
			{ ic: .093 }
		],
		836: [
			.694,
			-.508,
			.278,
			{ ic: .167 }
		],
		837: [
			-.068,
			.257,
			.11
		],
		838: [
			.698,
			-.512,
			0,
			{ dx: .147 }
		],
		839: [
			-.071,
			.373,
			0,
			{ dx: .256 }
		],
		840: [
			-.143,
			.323,
			0,
			{ dx: .313 }
		],
		841: [
			-.067,
			.308,
			0,
			{ dx: .204 }
		],
		842: [
			.771,
			-.474,
			.55,
			{ ic: .055 }
		],
		843: [
			.797,
			-.465,
			.55,
			{ ic: .055 }
		],
		844: [
			.837,
			-.503,
			.556,
			{ ic: .165 }
		],
		845: [
			-.025,
			.319,
			0,
			{ dx: .346 }
		],
		846: [
			-.031,
			.313,
			0,
			{ dx: .337 }
		],
		847: [
			0,
			0,
			0
		],
		848: [
			.789,
			-.495,
			.278,
			{ ic: .086 }
		],
		849: [
			.689,
			-.506,
			.223,
			{ ic: .081 }
		],
		850: [
			.817,
			-.533,
			.256
		],
		851: [
			-.085,
			.356,
			0,
			{ dx: .292 }
		],
		852: [
			-.017,
			.311,
			0,
			{ dx: .331 }
		],
		853: [
			-.017,
			.311,
			0,
			{ dx: .361 }
		],
		854: [
			-.017,
			.311,
			0,
			{ dx: .218 }
		],
		855: [
			.689,
			-.506,
			.223,
			{ ic: .073 }
		],
		856: [
			.672,
			-.567,
			0,
			{ dx: -.08 }
		],
		857: [
			-.041,
			.287,
			.317
		],
		858: [
			-.041,
			.224,
			.369
		],
		859: [
			.757,
			-.451,
			.5,
			{ ic: .087 }
		],
		860: [
			-.152,
			.431,
			0,
			{ dx: .381 }
		],
		861: [
			.765,
			-.486,
			0,
			{ dx: -.19 }
		],
		862: [
			.633,
			-.548,
			0,
			{ dx: -.115 }
		],
		863: [
			-.099,
			.184,
			0,
			{ dx: .03 }
		],
		864: [
			.722,
			-.562,
			0,
			{ dx: -.137 }
		],
		865: [
			.666,
			-.387,
			0
		],
		866: [
			-.011,
			.334,
			0,
			{ dx: .038 }
		],
		867: [
			.712,
			-.474,
			.294,
			{ ic: .11 }
		],
		868: [
			.715,
			-.477,
			.289,
			{ ic: .109 }
		],
		869: [
			.803,
			-.476,
			.13,
			{ ic: .139 }
		],
		870: [
			.714,
			-.476,
			.296,
			{ ic: .112 }
		],
		871: [
			.705,
			-.475,
			.267,
			{ ic: .119 }
		],
		872: [
			.712,
			-.474,
			.255,
			{ ic: .114 }
		],
		873: [
			.807,
			-.472,
			.273,
			{ ic: .142 }
		],
		874: [
			.809,
			-.478,
			.258,
			{ ic: .121 }
		],
		875: [
			.709,
			-.478,
			.442,
			{ ic: .108 }
		],
		876: [
			.708,
			-.478,
			.23,
			{ ic: .104 }
		],
		877: [
			.768,
			-.472,
			.222,
			{ ic: .114 }
		],
		878: [
			.703,
			-.476,
			.294,
			{ ic: .111 }
		],
		879: [
			.705,
			-.478,
			.32,
			{ ic: .097 }
		],
		7620: [
			.695,
			-.486,
			0,
			{ dx: .117 }
		],
		7621: [
			.695,
			-.486,
			0,
			{ dx: .173 }
		],
		7624: [
			.695,
			-.537,
			0,
			{ dx: .145 }
		],
		7625: [
			.695,
			-.537,
			0,
			{ dx: .145 }
		],
		9474: [
			.752,
			.253,
			.306,
			{ ic: .074 }
		],
		9553: [
			.752,
			.253,
			.531,
			{ ic: .078 }
		],
		9773: [
			.593,
			.001,
			.7,
			{ ic: .04 }
		],
		9792: [
			.48,
			.217,
			.55,
			{ ic: .034 }
		],
		9834: [
			.724,
			.052,
			.672,
			{ ic: .016 }
		],
		9901: [
			.484,
			-.022,
			.67,
			{ ic: .062 }
		],
		9902: [
			.629,
			.127,
			1.249,
			{ ic: .052 }
		],
		9906: [
			.48,
			.217,
			.55,
			{ ic: .034 }
		],
		10013: [
			.632,
			.028,
			.55,
			{ ic: .068 }
		],
		59395: [
			.706,
			0,
			.867,
			{ ic: .055 }
		],
		59908: [
			.866,
			-.519,
			.55,
			{ ic: .067 }
		],
		59909: [
			-.071,
			.213,
			.55
		],
		59910: [
			-.071,
			.213,
			.55
		],
		59913: [
			.866,
			-.545,
			.55,
			{ ic: .058 }
		],
		59915: [
			.923,
			-.545,
			.55,
			{ ic: .058 }
		],
		59917: [
			.687,
			-.545,
			.55,
			{ ic: .06 }
		],
		59920: [
			.888,
			-.545,
			.55,
			{ ic: .097 }
		],
		59927: [
			.841,
			-.535,
			.55,
			{ ic: .061 }
		],
		59930: [
			.841,
			-.535,
			.55,
			{ ic: .041 }
		],
		59932: [
			.898,
			-.535,
			.55,
			{ ic: .119 }
		],
		59934: [
			.863,
			-.535,
			.55,
			{ ic: .091 }
		],
		59935: [
			-.079,
			.292,
			.55
		],
		59942: [
			.694,
			-.537,
			.55,
			{ ic: .008 }
		],
		59946: [
			.858,
			-.564,
			.55,
			{ ic: .116 }
		],
		59948: [
			.846,
			-.564,
			.55,
			{ ic: .082 }
		],
		59951: [
			.858,
			-.564,
			.55,
			{ ic: .051 }
		],
		59957: [
			.719,
			-.513,
			.55
		],
		59962: [
			-.099,
			.184,
			.55
		],
		59966: [
			-.099,
			.184,
			.55
		],
		59970: [
			.863,
			-.526,
			.733
		],
		59973: [
			-.076,
			.207,
			.55
		],
		60163: [
			.885,
			.213,
			.733,
			{ ic: .031 }
		],
		60164: [
			.694,
			.213,
			.525,
			{ ic: .05 }
		],
		60168: [
			.694,
			0,
			.694,
			{ ic: .115 }
		],
		60175: [
			.694,
			0,
			.694,
			{ ic: .115 }
		],
		60176: [
			0,
			0,
			0
		],
		60177: [
			0,
			0,
			0
		],
		60178: [
			0,
			0,
			0
		],
		60182: [
			.631,
			.025,
			.55,
			{ ic: .066 }
		],
		60185: [
			-.085,
			.2,
			.306
		],
		60190: [
			.885,
			.213,
			.642,
			{ ic: .082 }
		],
		60191: [
			.694,
			.213,
			.511,
			{ ic: .05 }
		],
		60200: [
			.716,
			.022,
			1.222,
			{ ic: .042 }
		],
		60201: [
			.5,
			.244,
			.519
		],
		60203: [
			.844,
			.15,
			.733,
			{ ic: .057 }
		],
		60209: [
			.356,
			-.053,
			.367,
			{ ic: .011 }
		],
		60213: [
			.885,
			.213,
			.331,
			{ ic: .262 }
		],
		60214: [
			.694,
			.213,
			.256,
			{ ic: .187 }
		],
		60218: [
			.885,
			.022,
			.519,
			{ ic: .265 }
		],
		60219: [
			.694,
			.205,
			.286,
			{ ic: .187 }
		],
		60224: [
			.797,
			.073,
			1.1,
			{ ic: .184 }
		],
		60232: [
			.885,
			.213,
			.794,
			{ ic: .054 }
		],
		60233: [
			.694,
			.213,
			.55,
			{ ic: .051 }
		],
		60237: [
			.347,
			.056,
			.485
		],
		60257: [
			.416,
			-.292,
			.256,
			{ ic: .146 }
		],
		60259: [
			.667,
			-.486,
			.336,
			{ ic: .483 }
		],
		60261: [
			.694,
			-.563,
			.256,
			{ ic: .464 }
		],
		60270: [
			.694,
			.213,
			.764,
			{ ic: .052 }
		],
		60271: [
			.458,
			.213,
			.561,
			{ ic: .033 }
		],
		60424: [
			.877,
			0,
			.794,
			{ ic: .052 }
		],
		60425: [
			.877,
			0,
			.561,
			{ ic: .09 }
		],
		60426: [
			.877,
			0,
			.581
		],
		60427: [
			.877,
			0,
			.256,
			{ ic: .242 }
		],
		60428: [
			.877,
			0,
			.733,
			{ ic: .102 }
		],
		60429: [
			.772,
			.011,
			.404,
			{ ic: .098 }
		],
		60430: [
			.849,
			0,
			.733,
			{ ic: .102 }
		],
		60432: [
			.889,
			.194,
			.794,
			{ ic: .052 }
		],
		60433: [
			.653,
			.194,
			.55,
			{ ic: .048 }
		],
		61699: [
			.717,
			.022,
			1.222,
			{ ic: .039 }
		],
		61700: [
			.32,
			-.247,
			.733,
			{ ic: .063 }
		],
		61705: [
			.131,
			0,
			.672
		],
		61719: [
			.419,
			-.119,
			.255,
			{ ic: .08 }
		],
		61720: [
			.779,
			.05,
			.55,
			{ ic: .066 }
		],
		61721: [
			.761,
			.035,
			.489,
			{ ic: .074 }
		],
		61722: [
			.694,
			.217,
			.764,
			{ ic: .051 }
		],
		61723: [
			.458,
			.206,
			.592,
			{ ic: .028 }
		],
		61724: [
			.694,
			.195,
			.844,
			{ ic: .013 }
		],
		61725: [
			.694,
			.195,
			1.018,
			{ ic: .011 }
		],
		61726: [
			.694,
			.195,
			.703,
			{ ic: .05 }
		],
		61729: [
			.458,
			.162,
			.636,
			{ ic: .007 }
		],
		61730: [
			.458,
			.162,
			.782
		],
		61731: [
			.469,
			.311,
			.561,
			{ ic: .024 }
		],
		61734: [
			.694,
			.195,
			.58,
			{ ic: .103 }
		],
		61735: [
			.717,
			.022,
			.703,
			{ ic: .074 }
		],
		61736: [
			.458,
			.162,
			.418,
			{ ic: .083 }
		],
		61737: [
			.475,
			.013,
			.489,
			{ ic: .053 }
		],
		61738: [
			.694,
			.217,
			.978,
			{ ic: .054 }
		],
		61739: [
			.694,
			.217,
			.703,
			{ ic: .052 }
		],
		61740: [
			.458,
			.206,
			.744,
			{ ic: .03 }
		],
		61741: [
			.469,
			.322,
			.561,
			{ ic: .024 }
		],
		61743: [
			.811,
			.285,
			.611,
			{ ic: .107 }
		],
		61747: [
			.694,
			.002,
			.733
		],
		61748: [
			.871,
			0,
			.703,
			{ ic: .076 }
		],
		61749: [
			.471,
			.011,
			.696,
			{ ic: .055 }
		],
		61750: [
			.638,
			.011,
			.458,
			{ ic: .022 }
		],
		61751: [
			-.001,
			.226,
			.153
		],
		61752: [
			0,
			.216,
			.214,
			{ ic: .001 }
		],
		61757: [
			.722,
			-.521,
			.733,
			{ ic: .149 }
		],
		61761: [
			.695,
			-.537,
			.55,
			{ ic: .024 }
		],
		61762: [
			.695,
			-.537,
			.55
		],
		61763: [
			.316,
			-.001,
			.489
		],
		61764: [
			.316,
			-.001,
			.489
		],
		61765: [
			.695,
			-.412,
			.367,
			{ ic: .114 }
		],
		61766: [
			.684,
			-.389,
			.244,
			{ ic: .209 }
		],
		61771: [
			.068,
			.068,
			.367,
			{ ic: .071 }
		],
		61772: [
			.242,
			.068,
			.367,
			{ ic: .078 }
		],
		61773: [
			.415,
			.068,
			.367,
			{ ic: .074 }
		],
		61774: [
			.589,
			.068,
			.367,
			{ ic: .073 }
		],
		61775: [
			.762,
			.068,
			.367,
			{ ic: .07 }
		],
		61776: [
			.242,
			.068,
			.367,
			{ ic: .112 }
		],
		61777: [
			.415,
			.068,
			.367,
			{ ic: .148 }
		],
		61778: [
			.589,
			.068,
			.367,
			{ ic: .185 }
		],
		61779: [
			.762,
			.068,
			.367,
			{ ic: .223 }
		],
		61780: [
			.068,
			.068,
			.244,
			{ ic: .076 }
		],
		61781: [
			.242,
			.068,
			.244,
			{ ic: .077 }
		],
		61782: [
			.415,
			.068,
			.244,
			{ ic: .072 }
		],
		61783: [
			.589,
			.068,
			.244,
			{ ic: .07 }
		],
		61784: [
			.762,
			.068,
			.244,
			{ ic: .072 }
		],
		61785: [
			.242,
			.068,
			.244,
			{ ic: .112 }
		],
		61786: [
			.415,
			.068,
			.244,
			{ ic: .149 }
		],
		61787: [
			.589,
			.068,
			.244,
			{ ic: .187 }
		],
		61788: [
			.763,
			.068,
			.244,
			{ ic: .223 }
		],
		61791: [
			.695,
			-.478,
			.55
		],
		61792: [
			.695,
			-.486,
			.55
		],
		61793: [
			.695,
			-.536,
			.55
		],
		61794: [
			.695,
			-.536,
			.55
		],
		61795: [
			.695,
			-.531,
			.55,
			{ ic: .053 }
		],
		61796: [
			.695,
			-.531,
			.55,
			{ ic: .053 }
		],
		61797: [
			.469,
			.195,
			.342,
			{ ic: .034 }
		],
		61800: [
			.475,
			.016,
			.794,
			{ ic: .047 }
		],
		61804: [
			.458,
			.205,
			.286,
			{ ic: .037 }
		],
		61805: [
			.032,
			.206,
			.367
		],
		61806: [
			.116,
			.217,
			.244,
			{ ic: .04 }
		],
		61807: [
			.116,
			.217,
			.244
		],
		61808: [
			.115,
			.217,
			.306
		],
		61809: [
			.684,
			-.458,
			.378,
			{ ic: .085 }
		],
		61810: [
			.816,
			-.494,
			.489,
			{ ic: .11 }
		],
		61813: [
			.469,
			.011,
			.561,
			{ ic: .034 }
		],
		61817: [
			.711,
			.223,
			.55,
			{ ic: .058 }
		],
		61818: [
			.475,
			.223,
			.489,
			{ ic: .055 }
		],
		61819: [
			.695,
			.011,
			.76,
			{ ic: .084 }
		],
		61822: [
			.469,
			.217,
			.611,
			{ ic: .035 }
		],
		61823: [
			.469,
			.217,
			.611,
			{ ic: .036 }
		],
		61824: [
			.717,
			.217,
			.586,
			{ ic: .052 }
		],
		61826: [
			.696,
			.206,
			.36,
			{ ic: .043 }
		],
		61828: [
			.695,
			0,
			.867,
			{ ic: .041 }
		],
		61829: [
			.469,
			0,
			.683,
			{ ic: .029 }
		],
		61832: [
			.469,
			.011,
			.672,
			{ ic: .049 }
		],
		61833: [
			.469,
			.217,
			.592,
			{ ic: .057 }
		],
		61834: [
			.59,
			.011,
			.588,
			{ ic: .042 }
		],
		61835: [
			.469,
			.249,
			.404
		],
		61836: [
			.458,
			.258,
			.55,
			{ ic: .042 }
		],
		61837: [
			.48,
			.258,
			.55,
			{ ic: .036 }
		],
		61838: [
			.695,
			.069,
			.55,
			{ ic: .011 }
		],
		61839: [
			.695,
			.011,
			.55
		],
		61842: [
			.695,
			0,
			.372,
			{ ic: .083 }
		],
		61850: [
			.458,
			.002,
			.574,
			{ ic: .05 }
		],
		61854: [
			.459,
			0,
			.598,
			{ ic: .036 }
		],
		61855: [
			.458,
			0,
			.448,
			{ ic: .024 }
		],
		61857: [
			.474,
			.003,
			.604,
			{ ic: .011 }
		],
		61859: [
			.717,
			-.537,
			.55
		],
		61860: [
			.717,
			-.537,
			.55,
			{ ic: .055 }
		],
		61863: [
			.024,
			.217,
			.244
		],
		61864: [
			.024,
			.217,
			.244,
			{ ic: .04 }
		],
		61865: [
			-.111,
			.3,
			.55
		],
		61866: [
			-.112,
			.308,
			.55
		],
		61867: [
			.284,
			-.22,
			.305
		],
		61868: [
			.419,
			-.119,
			.255
		],
		61869: [
			-.112,
			.301,
			.55
		],
		61870: [
			-.111,
			.337,
			.55
		],
		61871: [
			-.1,
			.233,
			.55
		],
		61872: [
			-.011,
			.334,
			.611
		],
		61873: [
			.689,
			-.481,
			.611
		],
		61874: [
			.752,
			-.53,
			.55
		],
		61875: [
			.752,
			-.53,
			.55
		],
		61876: [
			.835,
			.335,
			1.222
		],
		61877: [
			.94,
			.44,
			1.222
		],
		62082: [
			.112,
			.001,
			.305
		],
		62083: [
			.735,
			-.528,
			.55
		],
		62110: [
			.747,
			-.53,
			.55
		],
		62113: [
			.694,
			.022,
			.703,
			{ ic: .055 }
		],
		62116: [
			.694,
			0,
			.764,
			{ ic: .055 }
		],
		62119: [
			.694,
			0,
			.764,
			{ ic: .055 }
		],
		62120: [
			.694,
			.194,
			1.223,
			{ ic: .037 }
		],
		62121: [
			.458,
			.011,
			.525,
			{ ic: .028 }
		],
		62124: [
			.458,
			0,
			.592,
			{ ic: .028 }
		],
		62126: [
			.458,
			0,
			.592,
			{ ic: .028 }
		],
		62127: [
			.458,
			.162,
			.836,
			{ ic: .028 }
		],
		62560: [
			.912,
			0,
			.733,
			{ ic: .001 }
		],
		62561: [
			.912,
			0,
			.642,
			{ ic: .084 }
		],
		62562: [
			.912,
			0,
			.764,
			{ ic: .085 }
		],
		62563: [
			.912,
			.022,
			.794,
			{ ic: .077 }
		],
		62564: [
			.912,
			0,
			.733,
			{ ic: .13 }
		],
		62565: [
			.912,
			0,
			.978,
			{ ic: .058 }
		],
		62566: [
			.912,
			.022,
			.703,
			{ ic: .075 }
		],
		62567: [
			.912,
			.022,
			1.14,
			{ ic: .052 }
		],
		62568: [
			.912,
			0,
			.703,
			{ ic: .058 }
		],
		62570: [
			.668,
			.01,
			.493,
			{ ic: .061 }
		],
		62571: [
			.668,
			.01,
			.48,
			{ ic: .066 }
		],
		62572: [
			.668,
			0,
			.592,
			{ ic: .008 }
		],
		62573: [
			.668,
			.01,
			.517,
			{ ic: .05 }
		],
		62574: [
			.661,
			.167,
			.47,
			{ ic: .08 }
		],
		62575: [
			.661,
			0,
			.744,
			{ ic: .003 }
		],
		62576: [
			.668,
			.011,
			.489,
			{ ic: .032 }
		],
		62577: [
			.668,
			.011,
			.8,
			{ ic: .024 }
		],
		62578: [
			.661,
			0,
			.555,
			{ ic: .017 }
		],
		63166: [
			.522,
			.033,
			.391,
			{ ic: .037 }
		],
		63187: [
			.878,
			-.763,
			.55,
			{ ic: .193 }
		],
		63188: [
			.666,
			-.52,
			.55,
			{ ic: .051 }
		],
		63189: [
			.678,
			-.529,
			.55,
			{ ic: .042 }
		],
		63190: [
			.68,
			-.528,
			.55
		],
		63198: [
			.319,
			-.247,
			.825,
			{ ic: .067 }
		],
		8592: [
			.548,
			.046,
			1.1
		],
		8593: [
			.668,
			.194,
			.622,
			{ ic: .079 }
		],
		8594: [
			.548,
			.046,
			1.1
		],
		8595: [
			.668,
			.194,
			.622,
			{ ic: .012 }
		],
		8730: [
			.807,
			.082,
			.519,
			{ ic: .25 }
		],
		8738: [
			.634,
			.134,
			.856,
			{ ic: .04 }
		],
		9001: [
			.761,
			.262,
			.428,
			{ ic: .107 }
		],
		9002: [
			.761,
			.262,
			.428,
			{ ic: .004 }
		],
		9702: [
			.418,
			-.114,
			.856
		],
		10214: [
			.75,
			.222,
			.545,
			{ ic: .111 }
		],
		10215: [
			.75,
			.222,
			.545,
			{ ic: .111 }
		]
	} }
}, "NCM"), {}, [
	"MJX-NCM-SSX",
	"MJX-NCM-SSBX",
	"MJX-NCM-SSIX",
	"MJX-NCM-SSBIX"
]);
//#endregion
